(function () {
  window.TPS_SCOOTER_V29_BOOTSTRAP = true;
  var PAGE_SIZE = 48;
  var DEFAULT_SORT = "most-relevant";
  var PRODUCT_FITMENT_LIMIT = 10;
  var MAKE_SECTION_LIMIT = 999;
  var MODEL_SECTION_LIMIT = 999;
  window.TPS_SCOOTER_MODEL_DATA = window.TPS_SCOOTER_MODEL_DATA || {};
  window.TPS_SCOOTER_MAKE_DATA = window.TPS_SCOOTER_MAKE_DATA || {};
  var MODEL_DATA = window.TPS_SCOOTER_MODEL_DATA;
  var MAKE_DATA = window.TPS_SCOOTER_MAKE_DATA;
  var pendingModelLoads = {};
  var pendingMakeLoads = {};
  var liveVariantCache = {};
  var liveVariantPending = {};
  var LIVE_VARIANT_ENDPOINT = "/apps/scooter-passing/api/live-variants";
  var SORT_OPTIONS = [
    ["most-relevant", "Meest relevant"],
    ["price-ascending", "Prijs laag-hoog"],
    ["price-descending", "Prijs hoog-laag"],
    ["title-ascending", "Letters A-Z"],
    ["title-descending", "Letters Z-A"],
  ];
  var DATA_ASSET_QUERY = "?codex=20260508fix1data";
  var DATA_ASSET_RETRY_QUERY = "?codex=20260508fix1retry";

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function ensureNativeRuntimeStyles() {
    if (document.getElementById("tps-scooter-v29-runtime-styles")) return;
    var style = document.createElement("style");
    style.id = "tps-scooter-v29-runtime-styles";
    style.textContent = [
      ".tps-scooter-page.is-native-layout .tps-native-current-filters{display:grid;gap:4px;list-style:none;margin:0 0 24px;padding:0}",
      ".tps-scooter-page.is-native-layout .tps-native-current-filters li{margin:0;padding:0}",
      ".tps-scooter-page.is-native-layout .tps-native-current-filters li:not(.strong) a.no-click{align-items:center;color:#4b5563;column-gap:4px;display:grid;font-weight:400!important;grid-template-columns:max-content minmax(0,1fr) 18px;line-height:1.35;padding-right:0;position:relative;text-decoration:none;white-space:normal;width:100%}",
      ".tps-scooter-page.is-native-layout .tps-native-current-filters li:not(.strong) a.no-click .tps-filter-label{color:#4b5563;font-weight:800!important;grid-column:1;margin-right:0;white-space:nowrap}",
      ".tps-scooter-page.is-native-layout .tps-native-current-filters li:not(.strong) a.no-click .tps-filter-value{color:#4b5563;font-weight:400!important;grid-column:2;min-width:0}",
      ".tps-scooter-page.is-native-layout .tps-native-current-filters li:not(.strong) a.no-click:after{color:#4b5563;content:'\\00d7';font-size:23px;font-weight:400;grid-column:3;justify-self:end;line-height:.9;position:static;transform:none}",
      ".tps-scooter-page.is-native-layout .tps-native-current-filters li.strong a{color:#4b5563;text-decoration:underline;text-underline-offset:2px}",
      ".tps-scooter-page.is-native-layout .tps-native-fieldset>header ul.desktop-only{display:grid;gap:4px;list-style:none!important;margin:0 0 24px;padding:0}",
      ".tps-scooter-page.is-native-layout .tps-native-fieldset>header ul.desktop-only li{list-style:none!important;margin:0;padding:0}",
      ".tps-scooter-page.is-native-layout .tps-native-fieldset>header ul.desktop-only li::marker{content:'';font-size:0}",
      ".tps-scooter-page.is-native-layout .tps-native-fieldset>header ul.desktop-only li:not(.strong) label{display:block;margin:0}",
      ".tps-scooter-page.is-native-layout .tps-native-fieldset>header ul.desktop-only li:not(.strong) a.no-click{align-items:center;color:#4b5563;column-gap:4px;display:grid;font-weight:400!important;grid-template-columns:max-content minmax(0,1fr) 18px;line-height:1.35;padding-right:0;position:relative;text-decoration:none;white-space:normal;width:100%}",
      ".tps-scooter-page.is-native-layout .tps-native-fieldset>header ul.desktop-only li:not(.strong) a.no-click .tps-filter-label{color:#4b5563;font-weight:800!important;grid-column:1;margin-right:0;white-space:nowrap}",
      ".tps-scooter-page.is-native-layout .tps-native-fieldset>header ul.desktop-only li:not(.strong) a.no-click .tps-filter-value{color:#4b5563;font-weight:400!important;grid-column:2;min-width:0}",
      ".tps-scooter-page.is-native-layout .tps-native-fieldset>header ul.desktop-only li:not(.strong) a.no-click:after{color:#4b5563;content:'\\00d7';font-size:23px;font-weight:400;grid-column:3;justify-self:end;line-height:.9;position:static;transform:none}",
      ".tps-scooter-page.is-native-layout .tps-native-fieldset>header ul.desktop-only li.strong a{color:#4b5563;text-decoration:underline;text-underline-offset:2px}",
      ".tps-scooter-page.is-native-layout .tps-theme-product-card .overlay-buy_button,.tps-scooter-page.is-native-layout .tps-theme-product-card .overlay-buy_button:visited,.tps-scooter-page.is-native-layout .tps-theme-product-card .overlay-buy_button:hover,.tps-scooter-page.is-native-layout .tps-theme-product-card .overlay-buy_button:focus{color:#fff!important}",
      ".tps-scooter-page.is-native-layout .stock.overlay-valid span,.tps-scooter-page.is-native-layout .stock.overlay-valid i{color:var(--alert_valid,#4acb95)!important}",
      ".tps-scooter-page.is-native-layout .tps-native-collection-wrapper{align-items:start;display:grid!important;column-gap:44px!important;gap:22px 44px!important;grid-template-columns:275px minmax(0,1fr)!important}",
      ".tps-scooter-page.is-native-layout .tps-native-results{padding-left:4px}",
      ".tps-scooter-page.is-native-layout .tps-theme-toolbar,.tps-scooter-page.is-native-layout .tps-results-head{display:none!important}",
      ".tps-scooter-page.is-native-layout .tps-native-head{margin:0 0 16px}",
      ".tps-scooter-page.is-native-layout .tps-native-head-row{align-items:start;display:grid;gap:12px;grid-template-columns:minmax(0,760px)}",
      ".tps-scooter-page.is-native-layout .tps-native-head .tps-theme-count{display:none}",
      ".tps-scooter-page.is-native-layout .tps-native-fieldset .tps-category--parent{color:#111827!important;font-size:14px;font-weight:800}",
      ".tps-scooter-page.is-native-layout .tps-native-fieldset .tps-category--parent>span>span{font-size:1em;font-weight:400}",
      ".tps-scooter-page.is-native-layout .tps-native-fieldset h4 .tps-native-filter-toggle{gap:4px!important;padding:0 16px!important}",
      ".tps-scooter-page.is-native-layout .tps-native-filter-toggle i{margin-left:2px!important}",
      ".tps-scooter-page.is-native-layout .tps-native-toolbar-form{color:#333;font-size:14px;margin:0 0 18px;overflow:visible!important;position:relative;z-index:4}",
      ".tps-scooter-page.is-native-layout .tps-native-toolbar-form fieldset{align-items:center;border-bottom:1px solid #e4e7ec;border-top:1px solid #e4e7ec;display:flex;flex-wrap:nowrap;gap:0 14px;min-width:0;overflow:visible!important;padding:13px 0}",
      ".tps-scooter-page.is-native-layout .tps-native-toolbar-form fieldset>hr{display:none!important}",
      ".tps-scooter-page.is-native-layout .tps-toolbar-search{display:block;flex:0 1 180px;margin:0;min-width:150px;width:180px}",
      ".tps-scooter-page.is-native-layout .tps-toolbar-search label{display:block;margin:0}",
      ".tps-scooter-page.is-native-layout .tps-toolbar-search input[type='search']{background:#fff;border:1px solid #d9e0e8;border-radius:3px;color:#333;font-size:14px;height:36px;line-height:36px;margin:0;max-width:100%;min-height:36px;padding:0 12px;width:100%}",
      ".tps-scooter-page.is-native-layout .tps-toolbar-search input[type='search']::placeholder{color:#6b7280;opacity:1}",
      ".tps-scooter-page.is-native-layout .tps-native-toolbar-form .hx{display:inline;flex:0 0 auto;font-weight:700;white-space:nowrap}",
      ".tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4in{align-items:center;color:#333;display:flex!important;flex:0 0 auto;gap:10px;line-height:1;margin:0 0 0 auto!important;padding:0!important}",
      ".tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4in li{margin:0;padding:0;position:relative}",
      ".tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4in input{opacity:0;pointer-events:none;position:absolute}",
      ".tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4in label{color:#333;cursor:pointer;font-weight:700;line-height:1;margin:0}",
      ".tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4in input:checked~label{text-decoration:underline;text-decoration-thickness:1px;text-underline-offset:2px}",
      ".tps-scooter-page.is-native-layout .tps-native-collection-wrapper:has(#collection.list) .tps-native-toolbar-form .l4in{display:none!important}",
      ".tps-scooter-page.is-native-layout .tps-native-collection-wrapper:has(#collection.list) .tps-native-toolbar-form .l4vw{margin-left:auto!important}",
      ".tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4vw{border-left:1px solid #e4e7ec;margin-left:0!important;padding-left:14px!important}",
      ".tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4vw li+li{padding-left:4px}",
      ".tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4vw a,.tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4vw a:hover,.tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4vw a:focus{color:#333!important;text-decoration:none!important;border-bottom:0!important}",
      ".tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4vw i{text-decoration:none!important;border-bottom:0!important}",
      ".tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4vw li.active a,.tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4vw li.active i,.tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4vw li.active i:before{color:var(--secondary_bg,#000096)!important}",
      ".tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4vw{border-left:0!important;position:relative}",
      ".tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4vw:before{background:#e4e7ec;content:'';height:16px;left:0;position:absolute;top:50%;transform:translateY(-50%);width:1px}",
      ".tps-scooter-page.is-native-layout .tps-toolbar-sort{align-items:center;border-left:1px solid #e4e7ec;display:flex;flex:0 0 auto;gap:8px;height:24px;line-height:1;margin:0;padding-left:14px;white-space:nowrap}",
      ".tps-scooter-page.is-native-layout .tps-toolbar-sort label{color:#333;font-size:14px;font-weight:400;line-height:1;margin:0}",
      ".tps-scooter-page.is-native-layout .tps-toolbar-sort select{appearance:auto;background:transparent;border:0;color:#111827;cursor:pointer;field-sizing:content;font-size:14px;font-weight:800;height:24px;line-height:1;margin:0;max-width:230px;min-height:24px;min-width:0;padding:0 26px 0 0;width:auto}",
      ".tps-scooter-page.is-native-layout .tps-toolbar-sort .select-wrapper,.tps-scooter-page.is-native-layout .tps-toolbar-sort .bv_mainselect{display:inline-block;min-width:130px;position:relative;width:auto!important}",
      ".tps-scooter-page.is-native-layout .tps-toolbar-sort .bv_atual{align-items:center;background:transparent!important;border:0!important;color:#111827!important;display:inline-flex!important;font-size:13px!important;font-weight:800!important;gap:5px;height:24px!important;line-height:1!important;min-width:130px;padding:0 8px 0 0!important;text-decoration:none!important;white-space:nowrap;width:auto!important}",
      ".tps-scooter-page.is-native-layout .tps-toolbar-sort .bv_atual .sl_inner{display:inline-block;max-width:138px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}",
      ".tps-scooter-page.is-native-layout .tps-toolbar-sort .arrows_bv,.tps-scooter-page.is-native-layout .tps-toolbar-sort .arrows_bv:before,.tps-scooter-page.is-native-layout .tps-toolbar-sort .arrows_bv:after,.tps-scooter-page.is-native-layout .tps-toolbar-sort i.arrow{content:''!important;display:none!important;font-size:0!important;height:0!important;line-height:0!important;width:0!important}",
      ".tps-scooter-page.is-native-layout .tps-toolbar-sort .bv_atual:after{align-self:center;border:solid currentColor;border-width:0 1.5px 1.5px 0;content:'';display:inline-block;flex:0 0 auto;height:6px;margin-left:3px;margin-top:0;position:relative;top:-1px;transform:rotate(45deg);width:6px}",
      ".tps-scooter-page.is-native-layout .tps-toolbar-sort .bv_ul_inner .li a{font-size:13px!important;line-height:1.25!important;padding-bottom:10px!important;padding-top:10px!important}",
      ".tps-scooter-page.is-native-layout .tps-toolbar-sort .bv_mainselect{display:none!important}",
      ".tps-scooter-page.is-native-layout .tps-toolbar-sort select[data-tps-sort]{appearance:auto!important;background:#fff!important;border:1px solid #d9e0e8!important;border-radius:3px!important;color:#111827!important;display:inline-block!important;font-size:13px!important;font-weight:700!important;height:32px!important;line-height:30px!important;max-width:190px!important;min-height:32px!important;opacity:1!important;padding:0 28px 0 10px!important;position:static!important;visibility:visible!important;width:auto!important}",
      ".tps-scooter-page.is-native-layout .tps-toolbar-sort .tps-sort-label{color:#333;font-size:14px;font-weight:400;line-height:1;margin:0}",
      ".tps-scooter-page.is-native-layout .tps-sort-box{display:inline-block;position:relative;top:-1px}",
      ".tps-scooter-page.is-native-layout .tps-sort-current,.tps-scooter-page.is-native-layout .tps-sort-current:hover,.tps-scooter-page.is-native-layout .tps-sort-current:focus{appearance:none!important;background:#fff!important;border:1px solid #d9e0e8!important;border-radius:3px!important;box-shadow:none!important;color:#111827!important;cursor:pointer;display:inline-block!important;font-size:13px!important;font-weight:800!important;height:26px!important;line-height:24px!important;margin:0!important;min-width:150px;padding:0 28px 0 10px!important;position:relative;text-align:left;text-decoration:none!important;text-transform:none!important;vertical-align:top;white-space:nowrap}",
      ".tps-scooter-page.is-native-layout .tps-sort-current:after{border:solid currentColor;border-width:0 1.5px 1.5px 0;content:'';height:6px;position:absolute;right:10px;top:7px;transform:rotate(45deg);width:6px}",
      ".tps-scooter-page.is-native-layout .tps-sort-box.is-open .tps-sort-current:after{top:10px;transform:rotate(225deg)}",
      ".tps-scooter-page.is-native-layout .tps-sort-menu{background:#fff;border:1px solid #d9e0e8;box-shadow:0 8px 20px rgba(17,24,39,.12);display:none;left:0;min-width:190px;position:absolute;top:calc(100% + 4px);z-index:60}",
      ".tps-scooter-page.is-native-layout .tps-sort-box.is-open .tps-sort-menu{display:grid}",
      ".tps-scooter-page.is-native-layout .tps-sort-option,.tps-scooter-page.is-native-layout .tps-sort-option:hover,.tps-scooter-page.is-native-layout .tps-sort-option:focus{appearance:none!important;background:#fff!important;border:0!important;border-radius:0!important;box-shadow:none!important;color:#111827!important;cursor:pointer;font-size:13px!important;font-weight:400;line-height:1.2;margin:0!important;padding:10px 12px!important;text-align:left;text-decoration:none!important;text-transform:none!important;white-space:nowrap;width:100%}",
      ".tps-scooter-page.is-native-layout .tps-sort-option:hover,.tps-scooter-page.is-native-layout .tps-sort-option:focus,.tps-scooter-page.is-native-layout .tps-sort-option.is-active{background:#f3f4f6!important;color:#111827!important}",
      ".tps-scooter-page.is-native-layout .tps-sort-option.is-active{font-weight:800!important}",
      ".tps-scooter-page.is-native-layout .tps-theme-product-card .static{padding-top:8px}",
      ".tps-scooter-page.is-native-layout .tps-theme-product-card .price.s1pr{line-height:1.25;margin-top:0!important}",
      ".tps-scooter-page.is-native-layout .tps-live-stock{font-size:13px;line-height:1.3;margin:5px 0 0;min-height:17px}",
      ".tps-scooter-page.is-native-layout .tps-live-stock span{color:var(--alert_valid,#149366)!important}",
      ".tps-scooter-page.is-native-layout .tps-live-stock.is-out span{color:#b42318!important}",
      ".tps-scooter-page.is-native-layout .tps-live-stock.is-low span{color:var(--alert_valid,#149366)!important}",
      ".tps-scooter-page.is-native-layout .tps-live-stock.is-loading span{color:#6b7280!important}",
      ".tps-scooter-page.is-native-layout .tps-live-stock i{color:inherit!important;font-size:10px;line-height:1;margin-right:3px;position:relative;top:-1px}",
      ".tps-scooter-page.is-native-layout .tps-live-stock i:before{font-size:10px!important}",
      ".tps-scooter-page.is-native-layout .tps-native-results [data-tps-product-grid]{margin-top:0}",
      ".tps-scooter-page.is-native-layout .tps-native-load-more{align-items:center;display:flex;flex-direction:column;margin:0;text-align:center;width:100%}",
      ".tps-scooter-page.is-native-layout .tps-native-load-more #load-more-info{width:100%}",
      ".tps-scooter-page.is-native-layout .tps-native-load-more .link-btn{display:flex;justify-content:center;margin-top:0;width:100%}",
      ".tps-scooter-page.is-native-layout .tps-native-load-more .link-btn a,.tps-scooter-page.is-native-layout .tps-native-load-more #load-more-button{min-width:0;width:auto}",
      ".tps-scooter-page.is-native-layout .tps-native-filter{box-sizing:border-box!important;overflow-x:hidden!important;overflow-y:auto!important;touch-action:pan-y}",
      ".tps-scooter-page.is-native-layout .tps-native-filter *{max-width:100%;box-sizing:border-box}",
      ".tps-scooter-page.is-native-layout .tps-native-filter .link-btn.submit{margin:16px 0 0;width:100%}",
      ".tps-scooter-page.is-native-layout .tps-native-filter .link-btn.submit a{box-sizing:border-box!important;display:block;max-width:100%!important;min-width:100%!important;text-align:center;width:100%!important}",
      ".tps-scooter-page .tps-finder-picker{position:relative;z-index:5}",
      ".tps-scooter-page .tps-finder-search{background:transparent!important;padding:0;position:relative}",
      ".tps-scooter-page .tps-finder-mobile-back{display:none!important}",
      ".tps-scooter-page .tps-finder-search>span{color:var(--tps-text,#101828);font-size:13px;font-weight:800}",
      ".tps-scooter-page .tps-finder-search label>span{color:var(--tps-text,#101828);font-size:13px;font-weight:800}",
      ".tps-scooter-page .tps-finder-search label{display:block;position:relative}",
      ".tps-scooter-page .tps-finder-search input{background:#fff!important;border:1px solid #cbd4df!important;border-radius:4px!important;box-shadow:none!important;font-size:14px;height:46px;line-height:46px;padding:0 44px 0 14px!important}",
      ".tps-scooter-page .tps-finder-clear{appearance:none!important;background:transparent!important;border:0!important;box-shadow:none!important;color:#667085!important;cursor:pointer;font-size:0!important;height:32px!important;line-height:32px!important;margin:0!important;padding:0!important;position:absolute;right:7px;top:calc(100% - 39px);width:32px!important;z-index:2}",
      ".tps-scooter-page .tps-finder-search .tps-finder-clear,.tps-scooter-page[data-tps-scooter-page] .tps-finder-search button.tps-finder-clear{display:block!important;height:32px!important;line-height:32px!important;max-width:32px!important;min-width:0!important;padding:0!important;right:7px!important;top:calc(100% - 39px)!important;width:32px!important}",
      ".tps-scooter-page .tps-finder-clear:before,.tps-scooter-page .tps-finder-clear:after{background:currentColor;content:'';height:14px;left:15px;position:absolute;top:9px;width:1.5px}.tps-scooter-page .tps-finder-clear:before{transform:rotate(45deg)}.tps-scooter-page .tps-finder-clear:after{transform:rotate(-45deg)}",
      ".tps-scooter-page .tps-finder-search input:focus{border-color:var(--tps-blue,#000096)!important;outline:2px solid rgba(0,0,150,.12);outline-offset:0}",
      ".tps-scooter-page .tps-finder-results[hidden]{display:none!important}",
      ".tps-scooter-page .tps-finder-results{background:#fff!important;border:1px solid #d9e0e8;box-shadow:0 14px 34px rgba(16,24,40,.16);box-sizing:border-box;display:grid;gap:10px;left:0;max-height:360px;overflow:auto;padding:12px;position:absolute;right:0;top:calc(100% + 8px);z-index:40}",
      ".tps-scooter-page .tps-finder-result{background:#fff!important;border:0!important;border-bottom:1px solid #eef2f6;border-radius:0!important;padding:9px 4px!important}",
      ".tps-scooter-page .tps-finder-result:last-child{border-bottom:0!important}",
      ".tps-scooter-page .tps-finder-result:hover{background:#f8faff!important}",
      ".tps-scooter-page .tps-scooter-page__hero--finder{overflow:visible!important}",
      ".tps-scooter-page .tps-finder-shell{display:block!important;max-width:980px;overflow:visible!important}",
      ".tps-scooter-page .tps-finder-picker{background:#fff!important;border-radius:8px;display:grid;gap:12px;grid-template-columns:minmax(0,1.5fr) minmax(260px,.8fr);padding:14px;position:relative;z-index:5}",
      ".tps-scooter-page .tps-finder-picker .tps-finder-controls{background:transparent!important;border-radius:0;grid-template-columns:minmax(0,1fr) minmax(0,1fr) auto;margin:0;padding:0}",
      ".tps-scooter-page .tps-finder-picker .tps-finder-search{align-self:end;background:transparent!important;color:var(--tps-text,#101828)!important;padding:0!important}",
      ".tps-scooter-page .tps-finder-picker .tps-finder-search>span{color:var(--tps-text,#101828)!important}",
      ".tps-scooter-page .tps-finder-picker .tps-finder-results{left:auto!important;right:14px!important;top:calc(100% - 14px)!important;width:min(420px,calc(100% - 28px))}",
      "@media(max-width:720px){.tps-scooter-page .tps-finder-picker{grid-template-columns:1fr;padding:10px}.tps-scooter-page .tps-finder-picker .tps-finder-controls{grid-template-columns:1fr}.tps-scooter-page .tps-finder-picker .tps-finder-results{left:10px!important;right:10px!important;top:calc(100% - 10px)!important;width:auto}}",
      ".tps-scooter-page .tps-finder-shell{display:block!important;max-width:980px;overflow:visible!important}",
      ".tps-scooter-page .tps-finder-picker{background:transparent!important;border-radius:0!important;display:grid;gap:14px;grid-template-columns:minmax(300px,.75fr) minmax(0,1.25fr);overflow:visible!important;padding:0!important;position:relative;z-index:5}",
      ".tps-scooter-page .tps-finder-picker .tps-finder-search{align-self:stretch;background:#fff!important;border-radius:8px;color:var(--tps-text,#101828)!important;display:grid;gap:7px;order:1;padding:14px!important;position:relative}",
      ".tps-scooter-page .tps-finder-picker .tps-finder-controls{align-self:stretch;background:#fff!important;border-radius:8px;grid-template-columns:minmax(0,1fr) minmax(0,1fr) auto;margin:0;order:3;padding:14px}",
      ".tps-scooter-page .tps-finder-picker .tps-finder-results{left:0!important;right:auto!important;top:calc(100% + 8px)!important;width:min(420px,calc((100% - 14px) * .375))!important}",
      ".tps-scooter-page .tps-scooter-page__hero--finder{box-sizing:border-box;display:block;margin-left:0;margin-right:auto;max-width:100%;width:max-content}",
      ".tps-scooter-page .tps-finder-make-label{position:relative}",
      ".tps-scooter-page .tps-finder-make-label select[data-tps-make]{height:1px!important;left:0!important;opacity:0!important;pointer-events:none!important;position:absolute!important;top:100%!important;width:1px!important}",
      ".tps-scooter-page .tps-finder-select{display:block;position:relative;width:100%}",
      ".tps-scooter-page .tps-finder-select__button{appearance:none!important;background:#fff!important;border:1px solid #cbd4df!important;border-radius:6px!important;box-shadow:none!important;color:var(--tps-text,#101828)!important;cursor:pointer;display:block;font-size:14px;font-weight:400;height:46px;line-height:44px;margin:0!important;overflow:hidden;padding:0 34px 0 12px!important;position:relative;text-align:left;text-overflow:ellipsis;white-space:nowrap;width:100%}",
      ".tps-scooter-page .tps-finder-select__button:after{border:solid currentColor;border-width:0 1.5px 1.5px 0;content:'';height:7px;position:absolute;right:18px;top:17px;transform:rotate(45deg);width:7px}",
      ".tps-scooter-page .tps-finder-controls .tps-finder-select__button:after{display:block!important;pointer-events:none!important;right:16px!important}",
      ".tps-scooter-page .tps-finder-select.is-open .tps-finder-select__button:after{top:20px;transform:rotate(225deg)}",
      ".tps-scooter-page .tps-finder-select__menu{background:#fff!important;border:1px solid #d9e0e8;border-radius:6px;box-shadow:0 14px 34px rgba(16,24,40,.18);box-sizing:border-box;display:none;left:0;max-height:320px;overflow-x:hidden;overflow-y:auto;padding:6px;position:absolute;right:0;top:calc(100% + 6px);z-index:90}",
      ".tps-scooter-page .tps-finder-select.is-open .tps-finder-select__menu{display:grid}",
      ".tps-scooter-page .tps-finder-select__option{appearance:none!important;background:#fff!important;border:0!important;border-radius:4px!important;box-shadow:none!important;color:var(--tps-text,#101828)!important;cursor:pointer;font-size:14px;font-weight:400;line-height:1.25;margin:0!important;padding:9px 28px 9px 10px!important;position:relative;text-align:left;width:100%}",
      ".tps-scooter-page .tps-finder-select__option:after{border:solid currentColor;border-width:0 1.5px 1.5px 0;content:'';height:7px;opacity:.55;position:absolute;right:12px;top:50%;transform:translateY(-50%) rotate(-45deg);width:7px}",
      ".tps-scooter-page .tps-finder-select__option:hover,.tps-scooter-page .tps-finder-select__option.is-active{background:#f3f6fb!important;color:var(--tps-blue,#000096)!important}",
      "@media(max-width:720px){.tps-scooter-page .tps-finder-picker{grid-template-columns:1fr}.tps-scooter-page .tps-finder-picker .tps-finder-controls{grid-template-columns:1fr;order:3}.tps-scooter-page .tps-finder-picker .tps-finder-results{left:0!important;right:0!important;top:calc(100% + 8px)!important;width:auto!important}}",
      ".tps-scooter-page .tps-scooter-page__hero--finder{display:block!important;margin-left:0!important;margin-right:auto!important;max-width:100%!important;width:100%!important}",
      ".tps-scooter-page .tps-finder-shell{max-width:none!important;width:100%!important}",
      ".tps-scooter-page .tps-finder-picker{grid-template-columns:minmax(360px,.85fr) minmax(0,1.15fr)!important;width:100%!important}",
      ".tps-scooter-page .tps-finder-picker .tps-finder-search{order:1!important}",
      ".tps-scooter-page .tps-finder-picker .tps-finder-controls{order:2!important}",
      ".tps-scooter-page .tps-finder-picker .tps-finder-results{left:0!important;right:auto!important;width:min(460px,calc((100% - 14px) * .425))!important}",
      ".tps-scooter-page .tps-finder-picker .tps-finder-search,.tps-scooter-page .tps-finder-picker .tps-finder-controls{box-sizing:border-box!important;min-height:118px!important;padding:18px 14px!important}",
      "@media(min-width:721px){.tps-scooter-page .tps-finder-picker .tps-finder-search,.tps-scooter-page .tps-finder-picker .tps-finder-controls{height:126px!important;min-height:126px!important}}",
      ".tps-scooter-page .tps-finder-picker .tps-finder-search{align-content:start!important}",
      ".tps-scooter-page .tps-finder-picker .tps-finder-controls{align-items:start!important;grid-auto-rows:auto!important}",
      ".tps-scooter-page .tps-finder-picker .tps-finder-controls label{align-content:start!important;align-self:start!important;display:grid!important;gap:8px!important}",
      ".tps-scooter-page .tps-finder-picker .tps-finder-controls button[data-tps-go]{align-self:end!important;height:46px!important;margin-top:25px!important;min-height:46px!important;padding-bottom:0!important;padding-top:0!important;position:relative!important;top:3px!important}",
      "@media(min-width:721px){.tps-scooter-page .tps-finder-picker .tps-finder-search input{margin-top:5px!important}}",
      ".tps-scooter-page .tps-finder-controls .tps-finder-select{margin-top:-1px!important}",
      ".tps-scooter-page .tps-finder-controls .tps-finder-select__button{background:#fff!important;border:1px solid #cbd4df!important;border-radius:6px!important;color:var(--tps-text,#101828)!important;font-size:14px!important;font-weight:400!important;height:46px!important;line-height:44px!important;min-width:0!important;padding:0 34px 0 12px!important;text-align:left!important;width:100%!important}",
      ".tps-scooter-page .tps-finder-controls .tps-finder-select__menu{background:#fff!important;border:1px solid #d9e0e8!important;border-radius:6px!important;box-shadow:0 14px 34px rgba(16,24,40,.18)!important;display:none;max-height:min(320px,calc(100vh - 120px));overflow-x:hidden!important;overflow-y:auto!important;z-index:90!important}",
      ".tps-scooter-page .tps-finder-controls .tps-finder-select.is-open .tps-finder-select__menu{display:grid!important}",
      ".tps-scooter-page .tps-finder-controls .tps-finder-select__option{background:#fff!important;border:0!important;border-radius:4px!important;color:var(--tps-text,#101828)!important;font-size:14px!important;font-weight:400!important;line-height:1.25!important;margin:0!important;min-height:0!important;min-width:0!important;padding:9px 28px 9px 10px!important;position:relative!important;text-align:left!important;width:100%!important}",
      ".tps-scooter-page .tps-finder-controls .tps-finder-select__option:hover,.tps-scooter-page .tps-finder-controls .tps-finder-select__option.is-active{background:#f3f6fb!important;color:var(--tps-blue,#000096)!important}",
      "@media(max-width:720px){.tps-scooter-page .tps-scooter-page__hero--finder{display:block!important;width:100%!important}.tps-scooter-page .tps-finder-picker{grid-template-columns:1fr!important;width:100%!important}.tps-scooter-page .tps-finder-picker .tps-finder-results{width:100%!important}}",
      "@media(max-width:720px){.tps-scooter-page .tps-finder-picker .tps-finder-search{order:1!important}.tps-scooter-page .tps-finder-picker .tps-finder-results{grid-column:1/-1!important;margin-top:-12px!important;max-height:320px!important;order:2!important;position:static!important;width:100%!important}.tps-scooter-page .tps-finder-picker .tps-finder-controls{order:3!important}}",
      "@media(max-width:720px){.tps-scooter-page.is-finder-search-open .tps-finder-picker .tps-finder-search{position:sticky!important;top:8px!important;z-index:120!important}.tps-scooter-page.is-finder-search-open .tps-finder-picker .tps-finder-results{left:auto!important;position:relative!important;right:auto!important;top:auto!important;z-index:110!important}}",
      "@media(max-width:720px){.tps-scooter-page.is-native-layout .tps-native-head-row{grid-template-columns:1fr}.tps-scooter-page.is-native-layout .tps-native-toolbar-form fieldset{flex-wrap:wrap;min-width:0}.tps-scooter-page.is-native-layout .tps-toolbar-search{flex:1 1 100%;width:100%}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4in{margin-left:auto!important}}",
      "@media(max-width:720px){.tps-scooter-page.is-native-layout .tps-native-toolbar-form fieldset{grid-template-columns:auto minmax(0,1fr) auto!important;row-gap:10px}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .link-btn.desktop-hide{grid-column:1/-1!important;grid-row:1!important;justify-self:start;margin:0}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .hx{grid-column:1!important;grid-row:2!important}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4vw{grid-column:3!important;grid-row:2!important;justify-self:end}.tps-scooter-page.is-native-layout .tps-toolbar-sort{grid-column:1/-1!important;grid-row:3!important;position:relative;z-index:40}.tps-scooter-page.is-native-layout .tps-toolbar-search{grid-column:1/-1!important;grid-row:4!important;position:relative;z-index:1}.tps-scooter-page.is-native-layout .tps-sort-box,.tps-scooter-page.is-native-layout .tps-sort-menu{z-index:80}.tps-scooter-page.is-native-layout .tps-sort-menu{top:calc(100% + 2px)}}",
      "@media(max-width:720px){html,body{max-width:100%;overflow-x:hidden}.tps-scooter-page.is-native-layout{box-sizing:border-box;max-width:100%;overflow-x:hidden;width:100%}.tps-scooter-page.is-native-layout .tps-native-collection-wrapper{box-sizing:border-box!important;display:block!important;grid-template-columns:1fr!important;margin-left:0!important;margin-right:0!important;max-width:100%!important;padding-left:12px!important;padding-right:12px!important;width:100%!important}.tps-scooter-page.is-native-layout .tps-native-results{box-sizing:border-box;min-width:0;padding-left:0!important;width:100%}.tps-scooter-page.is-native-layout .tps-native-toolbar-form{margin-bottom:14px}.tps-scooter-page.is-native-layout .tps-native-toolbar-form fieldset{align-items:center;display:grid!important;grid-template-columns:auto auto minmax(0,1fr) auto;column-gap:10px;row-gap:10px;min-width:0;overflow:visible!important;padding:12px 0}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .hx{font-weight:800!important;grid-column:1;grid-row:1}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .link-btn.desktop-hide{grid-column:2;grid-row:1;margin:0}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4in{display:none!important}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4vw{grid-column:4;grid-row:1;justify-self:end;margin:0!important;padding-left:10px!important}.tps-scooter-page.is-native-layout .tps-toolbar-sort{border-left:0!important;border-top:1px solid #e4e7ec;grid-column:1/-1;grid-row:2;height:auto;justify-content:flex-start;max-width:100%;min-width:0;padding:10px 0 0!important;width:100%}.tps-scooter-page.is-native-layout .tps-toolbar-sort label,.tps-scooter-page.is-native-layout .tps-toolbar-sort .tps-sort-label{flex:0 0 auto}.tps-scooter-page.is-native-layout .tps-toolbar-sort .select-wrapper{max-width:calc(100vw - 110px);min-width:0}.tps-scooter-page.is-native-layout .tps-toolbar-sort .bv_mainselect{display:none!important}.tps-scooter-page.is-native-layout .tps-toolbar-sort select[data-tps-sort]{font-size:13px!important;max-width:185px!important;min-width:145px!important;width:auto!important}.tps-scooter-page.is-native-layout .tps-sort-current{min-width:145px}.tps-scooter-page.is-native-layout .tps-sort-menu{left:auto;max-width:calc(100vw - 24px);min-width:180px;right:0}.tps-scooter-page.is-native-layout .tps-toolbar-search{grid-column:1/-1;grid-row:3;min-width:0!important;width:100%!important}.tps-scooter-page.is-native-layout #collection.mobile-scroll{column-gap:0!important;display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;margin-left:-12px!important;max-width:none!important;overflow:visible!important;padding-left:0!important;row-gap:22px!important;width:calc(100% + 8px)!important}.tps-scooter-page.is-native-layout #collection.list{grid-template-columns:1fr!important;margin-left:0!important;max-width:100%!important;width:100%!important}.tps-scooter-page.is-native-layout #collection>li{margin:0!important;min-width:0!important;width:auto!important}.tps-scooter-page.is-native-layout #collection figure img{height:auto;max-width:100%;width:100%}.tps-scooter-page.is-native-layout .tps-native-filter{max-width:88vw;overflow-x:hidden;width:88vw!important}.tps-scooter-page.is-native-layout .tps-native-filter fieldset{padding-top:0}.tps-scooter-page.is-native-layout .tps-native-filter header h3{align-items:center;background:var(--secondary_bg,#000096);color:#fff;display:flex;justify-content:space-between;margin:0 -18px 14px;padding:14px 18px}.tps-scooter-page.is-native-layout .tps-native-filter header h3 span{color:#fff}.tps-scooter-page.is-native-layout .tps-native-filter header h3 .header-toggle{color:#fff!important;font-size:0;text-decoration:none}.tps-scooter-page.is-native-layout .tps-native-filter header h3 .header-toggle:after{content:'\\00d7';font-size:26px;line-height:1}.tps-scooter-page.is-native-layout .tps-native-filter .desktop-hide.remove-all{display:none!important}}",
      "@media(max-width:720px){.tps-scooter-page.is-native-layout .tps-native-toolbar-form{overflow:visible!important;position:relative;z-index:20}.tps-scooter-page.is-native-layout .tps-native-toolbar-form fieldset{grid-template-columns:auto minmax(0,1fr) auto!important;overflow:visible!important}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .link-btn.desktop-hide{grid-column:1/-1!important;grid-row:1!important;justify-self:start!important}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .hx{grid-column:1!important;grid-row:2!important}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4vw{grid-column:3!important;grid-row:2!important}.tps-scooter-page.is-native-layout .tps-toolbar-sort{grid-column:1/-1!important;grid-row:3!important;overflow:visible!important;position:relative!important;z-index:2147483200!important}.tps-scooter-page.is-native-layout .tps-sort-box{position:relative!important;z-index:2147483210!important}.tps-scooter-page.is-native-layout .tps-sort-menu{position:absolute!important;z-index:2147483220!important}.tps-scooter-page.is-native-layout .tps-toolbar-search{grid-column:1/-1!important;grid-row:4!important;position:relative!important;z-index:0!important}.tps-scooter-page.is-native-layout .tps-toolbar-search,.tps-scooter-page.is-native-layout .tps-toolbar-search *{z-index:0!important}.tps-scooter-page.is-native-layout .tps-native-filter header h3,.tps-scooter-page.is-native-layout .tps-native-filter .tps-native-filter-title,.tps-scooter-page.is-native-layout .tps-native-filter ul.check{box-sizing:border-box!important;max-width:100%!important;width:100%!important}.tps-scooter-page.is-native-layout .tps-native-filter .tps-native-filter-title,.tps-scooter-page.is-native-layout .tps-native-filter ul.check{margin-left:0!important;margin-right:0!important}.tps-scooter-page.is-native-layout .tps-native-fieldset h4 .tps-native-filter-toggle{padding-left:0!important;padding-right:0!important}}",
      "@media(max-width:720px){.tps-scooter-page.is-native-layout .tps-native-filter header h3{box-sizing:border-box!important;margin:0 -18px 14px!important;max-width:none!important;width:calc(100% + 36px)!important}.tps-scooter-page.is-native-layout .tps-native-filter header{margin:0!important;max-width:none!important;overflow:visible!important;width:100%!important}.tps-scooter-page.is-native-layout .tps-native-filter .tps-native-filter-title,.tps-scooter-page.is-native-layout .tps-native-filter ul.check{max-width:none!important;width:100%!important}}",
      "@media(max-width:720px){html.tps-mobile-filter-active,body.tps-mobile-filter-active{overflow:hidden!important}.tps-scooter-page.is-native-layout.is-mobile-filter-open .tps-mobile-filter-backdrop{bottom:0!important;display:block!important;left:0!important;position:fixed!important;right:0!important;top:0!important;z-index:2147483000!important}.tps-scooter-page.is-native-layout.is-mobile-filter-open .tps-native-filter{background:#fff!important;bottom:0!important;box-sizing:border-box!important;display:block!important;height:100vh!important;height:100dvh!important;left:0!important;margin:0!important;max-height:100dvh!important;max-width:88vw!important;overflow-x:hidden!important;overflow-y:auto!important;padding:0 18px 18px!important;position:fixed!important;right:auto!important;top:0!important;transform:none!important;width:88vw!important;z-index:2147483001!important;-webkit-overflow-scrolling:touch!important}.tps-scooter-page.is-native-layout.is-mobile-filter-open .tps-native-filter legend{display:none!important}.tps-scooter-page.is-native-layout.is-mobile-filter-open .tps-native-filter fieldset{border:0!important;margin:0!important;min-height:100%!important;padding:0!important}.tps-scooter-page.is-native-layout.is-mobile-filter-open .tps-native-filter header h3{position:sticky!important;top:0!important;z-index:2!important}.tps-scooter-page.is-native-layout.is-mobile-filter-open .tps-native-filter a,.tps-scooter-page.is-native-layout.is-mobile-filter-open .tps-native-filter button,.tps-scooter-page.is-native-layout.is-mobile-filter-open .tps-native-filter input,.tps-scooter-page.is-native-layout.is-mobile-filter-open .tps-native-filter label{pointer-events:auto!important}}",
      "@media(max-width:1000px){html,body{max-width:100%;overflow-x:hidden}.tps-scooter-page.is-native-layout{background:#fff;box-sizing:border-box!important;margin-left:calc(50% - 50vw)!important;margin-right:calc(50% - 50vw)!important;max-width:100vw!important;overflow-x:hidden!important;padding-left:0!important;padding-right:0!important;width:100vw!important}.tps-scooter-page.is-native-layout .tps-native-collection-wrapper{box-sizing:border-box!important;display:block!important;float:none!important;grid-template-columns:1fr!important;margin-left:0!important;margin-right:0!important;max-width:100%!important;padding-left:12px!important;padding-right:12px!important;width:100%!important}.tps-scooter-page.is-native-layout .tps-native-results{box-sizing:border-box!important;display:block!important;float:none!important;flex-basis:auto!important;max-width:none!important;min-width:0!important;padding-left:0!important;width:100%!important}.tps-scooter-page.is-native-layout .tps-native-toolbar-form{box-sizing:border-box!important;max-width:100%!important;width:100%!important}.tps-scooter-page.is-native-layout #collection .price.s1pr{line-height:21px!important;margin-top:3px!important}}",
      "@media(max-width:720px){.tps-scooter-page.is-native-layout .tps-native-breadcrumb-section{padding-left:16px!important;padding-right:16px!important}.tps-scooter-page.is-native-layout .tps-native-collection-wrapper{padding-left:16px!important;padding-right:16px!important}.tps-scooter-page.is-native-layout .tps-native-toolbar-form fieldset{grid-template-columns:minmax(0,1fr) auto!important;row-gap:14px!important}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .link-btn.desktop-hide{grid-column:1/-1!important;grid-row:1!important;justify-self:start!important}.tps-scooter-page.is-native-layout .tps-toolbar-sort{border-top:0!important;grid-column:1/-1!important;grid-row:2!important;justify-content:flex-end!important;justify-self:end!important;padding-top:0!important;width:auto!important}.tps-scooter-page.is-native-layout .tps-toolbar-search{grid-column:1/-1!important;grid-row:4!important}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .hx{grid-column:1!important;grid-row:3!important}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4vw{grid-column:2!important;grid-row:3!important;justify-self:end!important}.tps-scooter-page.is-native-layout #collection.mobile-scroll{margin-left:-16px!important;max-width:none!important;width:calc(100% + 16px)!important}}",
      "@media(max-width:720px){.tps-scooter-page input[type='search'],.tps-scooter-page.is-native-layout .tps-toolbar-search input[type='search'],.tps-scooter-page .tps-finder-search input,[data-tps-scooter-page] input[type='search'],[data-tps-scooter-page] .tps-toolbar-search input[type='search'],[data-tps-scooter-page] .tps-finder-search input{font-size:16px!important}.tps-scooter-page__hero--finder,.tps-finder-shell,.tps-finder-picker,.tps-finder-search,.tps-finder-controls{box-sizing:border-box!important;max-width:100%!important;min-width:0!important}.tps-finder-shell,.tps-finder-picker,.tps-finder-search,.tps-finder-controls{width:100%!important}.tps-finder-picker{grid-template-columns:minmax(0,1fr)!important;overflow:visible!important;position:relative!important}.tps-scooter-page .tps-finder-mobile-back{display:none!important}.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-search{position:relative!important;top:auto!important;left:auto!important;right:auto!important;width:100%!important;z-index:50!important}.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-results.is-open{background:#fff!important;border:1px solid #d9e0e8!important;border-radius:6px!important;box-shadow:0 14px 34px rgba(16,24,40,.18)!important;box-sizing:border-box!important;display:block!important;gap:0!important;height:auto!important;left:14px!important;margin:0!important;max-height:238px!important;max-width:none!important;min-height:0!important;overflow-x:hidden!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;overscroll-behavior:contain!important;padding:6px!important;position:absolute!important;right:auto!important;scrollbar-color:#aeb8c5 transparent!important;scrollbar-width:thin!important;touch-action:auto!important;top:94px!important;width:calc(100% - 28px)!important;z-index:90!important}.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-results.is-open::-webkit-scrollbar{width:6px!important}.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-results.is-open::-webkit-scrollbar-thumb{background:#aeb8c5!important;border-radius:999px!important}.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-results.is-open *{pointer-events:auto!important}.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-results.is-open .tps-finder-result-section{display:block!important;margin:0!important}.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-results.is-open .tps-finder-result-section h3{display:none!important}.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-results.is-open .tps-finder-result{appearance:none!important;background:#fff!important;border:0!important;border-radius:4px!important;box-shadow:none!important;box-sizing:border-box!important;color:var(--tps-text,#101828)!important;cursor:pointer;display:block!important;font-size:14px!important;font-weight:400!important;line-height:1.25!important;margin:0!important;min-height:0!important;min-width:0!important;padding:9px 30px 9px 10px!important;position:relative!important;text-align:left!important;text-decoration:none!important;white-space:nowrap!important;width:100%!important}.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-results.is-open .tps-finder-result:after{border:solid currentColor;border-width:0 1.5px 1.5px 0;content:'';height:7px;opacity:.55;position:absolute;right:12px;top:50%;transform:translateY(-50%) rotate(-45deg);width:7px}.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-results.is-open .tps-finder-result:hover{background:#f3f6fb!important;color:var(--tps-blue,#000096)!important}.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-results.is-open .tps-finder-result span,.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-results.is-open .tps-finder-result em{display:none!important}.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-results.is-open .tps-finder-result strong{display:block!important;font-size:14px!important;font-weight:400!important;line-height:1.25!important;overflow:hidden!important;text-overflow:ellipsis!important;white-space:nowrap!important}.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-controls{box-sizing:border-box!important;max-width:100%!important;min-width:0!important;overflow:visible!important;width:100%!important}.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-select__menu{max-height:min(320px,55vh)!important;overflow-x:hidden!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;overscroll-behavior:contain!important;touch-action:auto!important;z-index:120!important}.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-controls label,.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-controls select,.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-controls button,.tps-scooter-page[data-tps-scooter-page] .tps-finder-picker .tps-finder-select{box-sizing:border-box!important;max-width:100%!important;min-width:0!important;width:100%!important}}",
      "@media(max-width:720px){.tps-scooter-page.is-native-layout .tps-native-toolbar-form fieldset{grid-template-columns:auto minmax(0,1fr)!important;row-gap:12px!important}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .link-btn.desktop-hide{grid-column:1!important;grid-row:1!important;justify-self:start!important}.tps-scooter-page.is-native-layout .tps-toolbar-sort{grid-column:2!important;grid-row:1!important;justify-self:end!important;padding-top:0!important;width:auto!important}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .hx{grid-column:1!important;grid-row:2!important}.tps-scooter-page.is-native-layout .tps-native-toolbar-form .l4vw{grid-column:2!important;grid-row:2!important;justify-self:end!important}.tps-scooter-page.is-native-layout .tps-toolbar-search{box-sizing:border-box!important;grid-column:1/-1!important;grid-row:3!important;max-width:calc(100vw - 32px)!important;min-width:0!important;width:100%!important}.tps-scooter-page.is-native-layout .tps-toolbar-search label,.tps-scooter-page.is-native-layout .tps-toolbar-search input[type='search']{box-sizing:border-box!important;max-width:100%!important;min-width:0!important;width:100%!important}.tps-scooter-page.is-native-layout .tps-toolbar-search input[type='search']{font-size:16px!important}.tps-scooter-page.is-native-layout .tps-native-toolbar-form,.tps-scooter-page.is-native-layout .tps-native-toolbar-form fieldset{box-sizing:border-box!important;max-width:100%!important;min-width:0!important}}",
      "@media(max-width:720px){.tps-scooter-page .tps-finder-make-label select[data-tps-make]{-webkit-appearance:none!important;appearance:none!important;background:#fff!important;background-image:none!important;border:1px solid #cbd4df!important;border-radius:6px!important;box-shadow:none!important;color:var(--tps-text,#101828)!important;display:block!important;font-size:16px!important;font-weight:400!important;height:46px!important;left:auto!important;line-height:44px!important;margin:0!important;opacity:1!important;padding:0 34px 0 12px!important;pointer-events:auto!important;position:static!important;top:auto!important;width:100%!important}.tps-scooter-page .tps-finder-make-label:after{border:solid currentColor;border-width:0 1.5px 1.5px 0;color:var(--tps-text,#101828);content:'';height:7px;pointer-events:none;position:absolute;right:14px;top:calc(100% - 29px);transform:rotate(45deg);width:7px;z-index:2}.tps-scooter-page .tps-finder-make-label .tps-finder-select{display:none!important}}",
    ].join("");
    document.head.appendChild(style);
  }

  function modelsPayload() {
    return window.TPS_SCOOTER_FITMENT_MODELS || { makes: [], modelsByLabel: {}, modelsBySlug: {} };
  }

  function normalizeLabel(value) {
    return String(value || "").trim().toLowerCase();
  }

  function normalizeSearch(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function alphaCompare(left, right, field) {
    return String((left || {})[field] || "").localeCompare(String((right || {})[field] || ""), "nl", {
      numeric: true,
      sensitivity: "base",
    });
  }

  function searchTokens(value) {
    var seen = {};
    return normalizeSearch(value)
      .split(/\s+/)
      .filter(Boolean)
      .filter(function (token) {
        if (seen[token]) return false;
        seen[token] = true;
        return true;
      });
  }

  function compactSearch(value) {
    return normalizeSearch(value).replace(/\s+/g, "");
  }

  function editDistanceAtMost(a, b, limit) {
    if (!a || !b) return false;
    if (Math.abs(a.length - b.length) > limit) return false;
    var prev = [];
    for (var j = 0; j <= b.length; j += 1) prev[j] = j;
    for (var i = 1; i <= a.length; i += 1) {
      var row = [i];
      var best = row[0];
      for (j = 1; j <= b.length; j += 1) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        row[j] = Math.min(prev[j] + 1, row[j - 1] + 1, prev[j - 1] + cost);
        if (row[j] < best) best = row[j];
      }
      if (best > limit) return false;
      prev = row;
    }
    return prev[b.length] <= limit;
  }

  function tokenMatchesWord(token, word) {
    if (!token || !word) return false;
    if (word.indexOf(token) >= 0) return true;
    if (token.length < 4 || word.length < 4) return false;
    return editDistanceAtMost(token, word, 1);
  }

  function fuzzyScore(text, tokens) {
    if (!tokens.length) return 1;
    var normalized = normalizeSearch(text);
    if (!normalized) return 0;
    var compactNormalized = normalized.replace(/\s+/g, "");
    var words = normalized.split(/\s+/).filter(Boolean);
    var score = 0;
    for (var i = 0; i < tokens.length; i += 1) {
      var token = tokens[i];
      var compactToken = compactSearch(token);
      if (normalized.indexOf(token) >= 0) {
        score += 12;
        continue;
      }
      if (compactToken && compactNormalized.indexOf(compactToken) >= 0) {
        score += 10;
        continue;
      }
      var matched = false;
      for (var j = 0; j < words.length; j += 1) {
        if (tokenMatchesWord(token, words[j])) {
          matched = true;
          score += 5;
          break;
        }
      }
      if (!matched) return 0;
    }
    return score;
  }

  function productSearchText(product) {
    return [
      product.sku,
      product.title,
      product.category,
      product.subcategory,
      (product.categories || []).join(" "),
    ].join(" ");
  }

  function productSearchScore(product, tokens) {
    if (!tokens.length) return 1;
    var score = fuzzyScore(productSearchText(product), tokens);
    if (!score) return 0;
    score += fuzzyScore(product.sku || "", tokens) * 4;
    score += fuzzyScore(product.title || "", tokens) * 2;
    return score;
  }

  function searchProducts(products, tokens) {
    if (!tokens.length) return products.slice();
    return products
      .map(function (product, index) {
        return { product: product, index: index, score: productSearchScore(product, tokens) };
      })
      .filter(function (row) {
        return row.score > 0;
      })
      .sort(function (a, b) {
        return b.score - a.score || a.index - b.index;
      })
      .map(function (row) {
        return row.product;
      });
  }

  function categoryCountsFromProducts(products) {
    var counts = {};
    products.forEach(function (product) {
      (product.categories || []).forEach(function (name) {
        if (!name) return;
        counts[name] = (counts[name] || 0) + 1;
      });
    });
    return Object.keys(counts)
      .map(function (name) {
        return { name: name, count: counts[name] };
      })
      .sort(function (a, b) {
        return alphaCompare(a, b, "name");
      });
  }

  function categoryGroupsFromProducts(products) {
    var groups = {};
    products.forEach(function (product) {
      var parentName = product.category || "Overig";
      var childName = product.subcategory && product.subcategory !== parentName ? product.subcategory : "";
      if (!groups[parentName]) groups[parentName] = { name: parentName, count: 0, children: {} };
      groups[parentName].count += 1;
      if (childName) groups[parentName].children[childName] = (groups[parentName].children[childName] || 0) + 1;
    });
    return Object.keys(groups)
      .map(function (name) {
        var group = groups[name];
        return {
          name: group.name,
          count: group.count,
          children: Object.keys(group.children)
            .map(function (childName) {
              return { name: childName, count: group.children[childName] };
            })
            .sort(function (a, b) {
              return alphaCompare(a, b, "name");
            }),
        };
      })
      .sort(function (a, b) {
        return alphaCompare(a, b, "name");
      });
  }

  function categoryDataFromProducts(products) {
    return {
      count: products.length,
      categories: categoryCountsFromProducts(products),
      categoryGroups: categoryGroupsFromProducts(products),
    };
  }

  function queryUrl(basePath, values) {
    var params = new URLSearchParams();
    Object.keys(values || {}).forEach(function (key) {
      var value = values[key];
      if (Array.isArray(value)) {
        value.forEach(function (item) {
          if (item !== undefined && item !== null && String(item).trim() !== "") {
            params.append(key, item);
          }
        });
        return;
      }
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        params.set(key, value);
      }
    });
    var query = params.toString();
    return query ? basePath + "?" + query : basePath;
  }

  function normalizeCategoryList(values) {
    var source = Array.isArray(values) ? values : [values];
    var seen = {};
    var result = [];
    source.forEach(function (value) {
      String(value == null ? "" : value)
        .split(",")
        .forEach(function (part) {
          var name = part.trim();
          if (!name || seen[name]) return;
          seen[name] = true;
          result.push(name);
        });
    });
    return result;
  }

  function categorySelected(categories, name) {
    return normalizeCategoryList(categories).indexOf(name) >= 0;
  }

  function toggleCategory(categories, name) {
    var current = normalizeCategoryList(categories);
    if (!name) return [];
    if (current.indexOf(name) >= 0) {
      return current.filter(function (item) {
        return item !== name;
      });
    }
    return current.concat(name);
  }

  function stateUrlValues(state) {
    var sort = normalizeSort(state && state.sort);
    return {
      pagina: state && state.page > 1 ? state.page : "",
      categorie: normalizeCategoryList(state && (state.categories || state.category)),
      zoek: state && state.searchQuery,
      op_voorraad: state && state.inStock ? "1" : "",
      sort_by: sort !== DEFAULT_SORT ? sort : "",
    };
  }

  function modelUrl(basePath, state) {
    return queryUrl(basePath, stateUrlValues(state || {}));
  }

  function categoryUrl(basePath, categories, category, searchQuery, inStock, sort) {
    return modelUrl(basePath, {
      categories: toggleCategory(categories, category),
      searchQuery: searchQuery,
      inStock: inStock,
      sort: sort,
      page: 1,
    });
  }

  function stockUrl(basePath, categories, searchQuery, inStock, sort) {
    return modelUrl(basePath, {
      categories: categories,
      searchQuery: searchQuery,
      inStock: !inStock,
      sort: sort,
      page: 1,
    });
  }

  function clearFiltersUrl(basePath, searchQuery, sort) {
    return modelUrl(basePath, {
      searchQuery: searchQuery,
      page: 1,
    });
  }

  function normalizeSort(value) {
    var sort = String(value || DEFAULT_SORT);
    var allowed = {
      "most-relevant": true,
      "title-ascending": true,
      "title-descending": true,
      "price-ascending": true,
      "price-descending": true,
    };
    return allowed[sort] ? sort : DEFAULT_SORT;
  }

  function sortLabel(value) {
    var sort = normalizeSort(value);
    for (var i = 0; i < SORT_OPTIONS.length; i += 1) {
      if (SORT_OPTIONS[i][0] === sort) return SORT_OPTIONS[i][1];
    }
    return "Meest relevant";
  }

  function sortValueFromLabel(label) {
    var wanted = String(label || "").replace(/\s+/g, " ").trim().toLowerCase();
    for (var i = 0; i < SORT_OPTIONS.length; i += 1) {
      if (SORT_OPTIONS[i][1].toLowerCase() === wanted) return SORT_OPTIONS[i][0];
    }
    if (wanted.indexOf("uitgelicht") === 0) return "manual";
    if (wanted.indexOf("meest relevant") === 0) return "most-relevant";
    if (wanted.indexOf("best verko") === 0) return "best-selling";
    if (wanted.indexOf("alfabetisch: a") === 0) return "title-ascending";
    if (wanted.indexOf("alfabetisch: z") === 0) return "title-descending";
    if (wanted.indexOf("letter: a") === 0) return "title-ascending";
    if (wanted.indexOf("letter: z") === 0) return "title-descending";
    if (wanted.indexOf("letters a") === 0) return "title-ascending";
    if (wanted.indexOf("letters z") === 0) return "title-descending";
    if (wanted.indexOf("prijs: laag") === 0) return "price-ascending";
    if (wanted.indexOf("prijs: hoog") === 0) return "price-descending";
    if (wanted.indexOf("datum: oud") === 0) return "created-ascending";
    if (wanted.indexOf("datum: nieuw") === 0) return "created-descending";
    return "";
  }

  function renderSortOptions(current) {
    var sort = normalizeSort(current);
    return SORT_OPTIONS.map(function (option) {
      return '<option value="' + option[0] + '"' + (option[0] === sort ? " selected" : "") + ">" + escapeHtml(option[1]) + "</option>";
    }).join("");
  }

  function renderSimpleSortOptions(current) {
    var sort = normalizeSort(current);
    return SORT_OPTIONS.map(function (option) {
      return (
        '<a href="#" class="tps-sort-option' +
        (option[0] === sort ? " is-active" : "") +
        '" data-tps-sort-choice="' +
        option[0] +
        '">' +
        escapeHtml(option[1]) +
        "</a>"
      );
    }).join("");
  }

  function productCountLabel(count) {
    return count + " " + (Number(count) === 1 ? "product" : "producten");
  }

  function setProductCountText(node, count) {
    if (node) node.textContent = productCountLabel(count);
  }

  function normalizeProductCountText(root) {
    (root || document).querySelectorAll("[data-tps-toolbar-count], [data-tps-model-summary]").forEach(function (node) {
      var match = String(node.textContent || "").match(/^\s*(\d+)\s+producten\s*$/i);
      if (match && Number(match[1]) === 1) node.textContent = productCountLabel(match[1]);
    });
  }

  function syncSortSelect(select) {
    if (!select) return;
    var label = sortLabel(select.value);
    Array.prototype.forEach.call(select.options || [], function (option) {
      option.textContent = sortLabel(option.value);
    });
    var wrapper = select.closest(".select-wrapper") || select.parentElement;
    if (wrapper) {
      wrapper.querySelectorAll(".tps-toolbar-sort .arrows_bv, .bv_atual .arrows_bv").forEach(function (icon) {
        icon.parentNode.removeChild(icon);
      });
    }
    var current = wrapper ? wrapper.querySelector(".bv_atual .sl_inner") : null;
    if (current) current.textContent = label;
    if (wrapper) {
      wrapper.querySelectorAll(".bv_ul_inner .li").forEach(function (item) {
        var text = item.querySelector(".text");
        if (!text) return;
        var value = sortValueFromLabel(text.textContent);
        if (value) text.textContent = sortLabel(value);
        item.classList.toggle("bv_selected", text.textContent.trim() === label);
      });
    }
  }

  function syncSimpleSort(root, sort) {
    var value = normalizeSort(sort);
    var box = root.querySelector("[data-tps-sort-box]");
    var current = root.querySelector("[data-tps-sort-current]");
    if (current) {
      current.textContent = sortLabel(value);
      current.setAttribute("aria-expanded", box && box.classList.contains("is-open") ? "true" : "false");
    }
    root.querySelectorAll("[data-tps-sort-choice]").forEach(function (button) {
      button.classList.toggle("is-active", button.getAttribute("data-tps-sort-choice") === value);
    });
  }

  function priceValue(product) {
    var raw = (product || {}).price;
    if (typeof raw === "number") return Number.isFinite(raw) ? raw : 0;
    var value = String(raw || "").trim().replace(/[^\d,.-]/g, "");
    if (value.indexOf(",") >= 0 && value.indexOf(".") >= 0) {
      value = value.replace(/\./g, "").replace(",", ".");
    } else if (value.indexOf(",") >= 0) {
      value = value.replace(",", ".");
    }
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function sortProducts(products, sort) {
    var mode = normalizeSort(sort);
    if (mode === "title-ascending") {
      return products.slice().sort(function (a, b) {
        return alphaCompare(a, b, "title");
      });
    }
    if (mode === "title-descending") {
      return products.slice().sort(function (a, b) {
        return alphaCompare(b, a, "title");
      });
    }
    if (mode === "price-ascending" || mode === "price-descending") {
      return products
        .map(function (product, index) {
          return { product: product, index: index, price: priceValue(product) };
        })
        .sort(function (a, b) {
          var diff = mode === "price-ascending" ? a.price - b.price : b.price - a.price;
          return diff || alphaCompare(a.product, b.product, "title") || a.index - b.index;
        })
        .map(function (row) {
          return row.product;
        });
    }
    return products.slice();
  }

  function knownModelFor(label) {
    var payload = modelsPayload();
    var exact = payload.modelsByLabel && payload.modelsByLabel[normalizeLabel(label)];
    if (exact) return exact;
    var wanted = normalizeLabel(label);
    if (!wanted) return null;
    var all = payload.models || [];
    for (var i = 0; i < all.length; i += 1) {
      var candidate = all[i];
      var known = normalizeLabel(candidate.label);
      if (wanted.indexOf(known) === 0) return candidate;
    }
    return null;
  }

  function pageUrlForModel(model) {
    return "/pages/scooter-" + model.slug;
  }

  function pageUrlForMake(make) {
    return "/pages/scooter-" + make.slug;
  }

  function countLabel(count, singular, plural) {
    return count + " " + (Number(count) === 1 ? singular : plural);
  }

  function makeLabel(make) {
    return (make && (make.displayName || make.label || make.name)) || "";
  }

  function formatPrice(value) {
    var number = Number(String(value || "").replace(",", "."));
    if (!Number.isFinite(number) || number <= 0) return "";
    return "\u20ac " + number.toFixed(2).replace(".", ",");
  }

  function formatCents(value) {
    var cents = Number(value || 0);
    if (!Number.isFinite(cents) || cents <= 0) return "";
    return "\u20ac" + (cents / 100).toFixed(2).replace(".", ",");
  }

  function stockLabel(product) {
    if (!product.variantId) return { text: "Bekijk product", className: "is-neutral" };
    if (!product.available) return { text: "Niet op voorraad", className: "is-out" };
    var qty = Number(product.availableQuantity || 0);
    if (qty > 0 && qty <= 5) return { text: "Nog " + qty + " op voorraad", className: "is-low" };
    return { text: "Op voorraad", className: "is-in" };
  }

  function liveStockLabel(row) {
    if (!row || !row.variantId) return { text: "", className: "is-loading" };
    if (!row.available) return { text: "Niet op voorraad", className: "is-out" };
    var qty = Number(row.availableQuantity || 0);
    if (qty > 0 && qty <= 5) return { text: "Nog " + qty + " op voorraad", className: "is-low" };
    return { text: "Op voorraad", className: "is-in" };
  }

  function livePriceText(row) {
    var price = row && row.price;
    if (price && price.text) return String(price.text).replace("\u20ac ", "\u20ac");
    if (price && price.cents != null) return formatCents(price.cents);
    return "";
  }

  function productHandleFromUrl(url) {
    var match = String(url || "").match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function assetBase(root) {
    return root.getAttribute("data-assets-base") || "";
  }

  function getModelData(slug) {
    return window.TPS_SCOOTER_MODEL_DATA && window.TPS_SCOOTER_MODEL_DATA[slug];
  }

  function getMakeData(slug) {
    return window.TPS_SCOOTER_MAKE_DATA && window.TPS_SCOOTER_MAKE_DATA[slug];
  }

  function loadScriptBackedData(root, slug, pendingLoads, getter, assetName, missingMessage, loadMessage) {
    var cached = getter(slug);
    if (cached) return Promise.resolve(cached);
    if (pendingLoads[slug]) return pendingLoads[slug];
    pendingLoads[slug] = new Promise(function (resolve, reject) {
      var settled = false;
      var pollTimer = 0;
      var retryTimer = 0;
      var timeoutTimer = 0;

      function cleanup() {
        window.clearInterval(pollTimer);
        window.clearTimeout(retryTimer);
        window.clearTimeout(timeoutTimer);
      }

      function finishWithData(data) {
        if (settled) return;
        settled = true;
        cleanup();
        resolve(data);
      }

      function fail(error) {
        if (settled) return;
        var loaded = getter(slug);
        if (loaded) {
          finishWithData(loaded);
          return;
        }
        settled = true;
        cleanup();
        delete pendingLoads[slug];
        reject(error);
      }

      function checkLoaded() {
        var loaded = getter(slug);
        if (!loaded) return false;
        finishWithData(loaded);
        return true;
      }

      function appendScript(query, isRetry) {
        if (settled || checkLoaded()) return;
        var src = assetBase(root) + assetName + slug + ".js" + query;
        var existing = document.querySelector('script[src="' + src.replace(/"/g, '\\"') + '"]');
        if (existing && !isRetry) return;
        var script = document.createElement("script");
        script.async = true;
        script.src = src;
        script.onload = function () {
          if (!checkLoaded()) fail(new Error(missingMessage + slug));
        };
        script.onerror = function () {
          if (isRetry) fail(new Error(loadMessage + slug));
        };
        document.head.appendChild(script);
      }

      pollTimer = window.setInterval(checkLoaded, 120);
      appendScript(DATA_ASSET_QUERY, false);
      retryTimer = window.setTimeout(function () {
        appendScript(DATA_ASSET_RETRY_QUERY, true);
      }, 3500);
      timeoutTimer = window.setTimeout(function () {
        fail(new Error(loadMessage + slug));
      }, 12000);
    });
    return pendingLoads[slug];
  }

  function loadModelData(root, slug) {
    return loadScriptBackedData(
      root,
      slug,
      pendingModelLoads,
      getModelData,
      "tps-scooter-model-v23-",
      "Modeldata niet gevonden: ",
      "Modeldata kon niet laden: "
    );
  }

  function loadMakeData(root, slug) {
    return loadScriptBackedData(
      root,
      slug,
      pendingMakeLoads,
      getMakeData,
      "tps-scooter-make-v23-",
      "Merkdata niet gevonden: ",
      "Merkdata kon niet laden: "
    );
  }

  function loadDetailData(root, slug, kind) {
    if (kind === "model") return loadModelData(root, slug);
    if (kind === "make") return loadMakeData(root, slug);
    var first = slug.indexOf("-") < 0 ? loadMakeData : loadModelData;
    var second = first === loadMakeData ? loadModelData : loadMakeData;
    return first(root, slug).catch(function () {
      return second(root, slug);
    });
  }

  window.TPS_REGISTER_SCOOTER_MODEL = function (payload) {
    if (!payload || !payload.slug) return;
    window.TPS_SCOOTER_MODEL_DATA = window.TPS_SCOOTER_MODEL_DATA || {};
    window.TPS_SCOOTER_MODEL_DATA[payload.slug] = payload;
    MODEL_DATA = window.TPS_SCOOTER_MODEL_DATA;
  };

  window.TPS_REGISTER_SCOOTER_MAKE = function (payload) {
    if (!payload || !payload.slug) return;
    window.TPS_SCOOTER_MAKE_DATA = window.TPS_SCOOTER_MAKE_DATA || {};
    window.TPS_SCOOTER_MAKE_DATA[payload.slug] = payload;
    MAKE_DATA = window.TPS_SCOOTER_MAKE_DATA;
  };

  function initProductFitment() {
    document.querySelectorAll("[data-tps-product-fitment]").forEach(function (root) {
      if (root.getAttribute("data-ready") === "1") return;
      root.setAttribute("data-ready", "1");
      var raw = root.getAttribute("data-models") || "[]";
      var labels = [];
      try {
        labels = JSON.parse(raw) || [];
      } catch (error) {
        labels = [];
      }
      var seen = {};
      var models = labels
        .map(knownModelFor)
        .filter(Boolean)
        .filter(function (model) {
          if (seen[model.slug]) return false;
          seen[model.slug] = true;
          return true;
        })
        .sort(function (a, b) {
          return alphaCompare(a, b, "label");
        });
      if (!models.length) {
        root.innerHTML = "";
        return;
      }
      var visibleModels = models.slice(0, PRODUCT_FITMENT_LIMIT);
      var extra = models.length - visibleModels.length;
      root.innerHTML =
        '<div class="tps-fitment__head">' +
        '<span class="tps-fitment__mark" aria-hidden="true">&#10003;</span>' +
        '<div><p class="tps-eyebrow">Scooter passing</p><h3>Past op deze scooters</h3>' +
        '<p class="tps-fitment__intro">Klik op je model en bekijk meteen alle passende onderdelen.</p></div>' +
        "</div>" +
        '<div class="tps-chip-row">' +
        visibleModels
          .map(function (model) {
            return '<a class="tps-chip" href="' + pageUrlForModel(model) + '">' + escapeHtml(model.label) + "</a>";
          })
          .join("") +
        (extra > 0 ? '<span class="tps-chip tps-chip--muted">+' + extra + " meer</span>" : "") +
        "</div>";
    });
  }

  function finderResultsHtml(makes, query) {
    var tokens = searchTokens(query);
    var makeRows = makes
      .map(function (make) {
        var label = makeLabel(make);
        return {
          type: "Merk",
          label: label,
          subtitle: countLabel(make.count || 0, "artikel", "artikelen"),
          url: pageUrlForMake(make),
          score: tokens.length ? fuzzyScore(label + " " + make.name, tokens) : 1,
        };
      })
      .filter(function (row) {
        return row.score > 0;
      })
      .sort(function (a, b) {
        return tokens.length ? b.score - a.score || alphaCompare(a, b, "label") : alphaCompare(a, b, "label");
      });
    var modelRows = [];
    if (tokens.length) {
      makes.forEach(function (make) {
        (make.models || []).forEach(function (model) {
          modelRows.push({
            type: makeLabel(make),
            label: model.label,
            subtitle: countLabel(model.count || 0, "artikel", "artikelen"),
            url: pageUrlForModel(model),
            score: fuzzyScore(model.label + " " + model.model + " " + make.name + " " + makeLabel(make), tokens),
          });
        });
      });
      modelRows = modelRows
        .filter(function (row) {
          return row.score > 0;
        })
        .sort(function (a, b) {
          return b.score - a.score || alphaCompare(a, b, "label");
        });
    }

    function section(title, rows, limit) {
      if (!rows.length) return "";
      var visibleRows = rows.slice(0, limit || rows.length);
      return (
        '<section class="tps-finder-result-section"><h3>' +
        escapeHtml(title) +
        "</h3>" +
        visibleRows
          .map(function (row) {
            return (
              '<a class="tps-finder-result" href="' +
              escapeHtml(row.url) +
              '"><span>' +
              escapeHtml(row.type) +
              "</span><strong>" +
              escapeHtml(row.label) +
              "</strong><em>" +
              escapeHtml(row.subtitle) +
              "</em></a>"
            );
          })
          .join("") +
        "</section>"
      );
    }

    if (!tokens.length) return "";
    var html = section("Merken", makeRows, 6) + section("Modellen", modelRows, 12);
    return html || '<p class="tps-search-empty">Geen merk of model gevonden.</p>';
  }

  function isMobileViewport() {
    return !!(window.matchMedia && window.matchMedia("(max-width: 720px)").matches);
  }

  function setFinderMobileSearchActive(active) {
    document.documentElement.classList.remove("tps-finder-mobile-search-active");
    document.body.classList.remove("tps-finder-mobile-search-active");
  }

  function renderFinderResults(root, makes) {
    var input = root.querySelector("[data-tps-finder-search]");
    var target = root.querySelector("[data-tps-finder-results]");
    if (!target) return;
    var query = input ? input.value : "";
    var html = finderResultsHtml(makes, query);
    var open = !!html && searchTokens(query).length > 0;
    target.innerHTML = html;
    target.hidden = !open;
    target.classList.toggle("is-open", open);
    target.setAttribute("aria-hidden", open ? "false" : "true");
    if (input) input.setAttribute("aria-expanded", open ? "true" : "false");
    root.classList.toggle("is-finder-search-open", open);
    setFinderMobileSearchActive(open);
    if (open) enableTouchScrollbox(target);
    if (open && input && window.matchMedia && window.matchMedia("(max-width: 720px)").matches) {
      if (target.getAttribute("data-tps-mobile-opened") !== "1") {
        target.setAttribute("data-tps-mobile-opened", "1");
        target.scrollTop = 0;
      }
      var anchor = input.closest ? input.closest(".tps-finder-search") : input;
      if (anchor && input.getAttribute("data-tps-mobile-anchored") !== "1") {
        input.setAttribute("data-tps-mobile-anchored", "1");
        window.setTimeout(function () {
          var top = anchor.getBoundingClientRect().top + window.pageYOffset - 12;
          window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
        }, 0);
      }
    }
  }

  function closeFinderResults(root) {
    var input = root.querySelector("[data-tps-finder-search]");
    var target = root.querySelector("[data-tps-finder-results]");
    if (!target) return;
    target.hidden = true;
    target.classList.remove("is-open");
    target.setAttribute("aria-hidden", "true");
    target.removeAttribute("data-tps-mobile-opened");
    root.classList.remove("is-finder-search-open");
    setFinderMobileSearchActive(false);
    if (input) {
      input.setAttribute("aria-expanded", "false");
      input.removeAttribute("data-tps-mobile-anchored");
    }
  }

  function enableTouchScrollbox(element) {
    if (!element || element.getAttribute("data-tps-touch-scroll") === "1") return;
    element.setAttribute("data-tps-touch-scroll", "1");
    var startY = 0;
    var startTop = 0;
    var didMove = false;
    element.addEventListener("wheel", function (event) {
      if (element.scrollHeight <= element.clientHeight + 1) return;
      event.stopPropagation();
    });
    element.addEventListener("touchstart", function (event) {
      if (element.scrollHeight <= element.clientHeight + 1 || !event.touches || !event.touches.length) return;
      startY = event.touches[0].clientY;
      startTop = element.scrollTop;
      didMove = false;
    }, { passive: true });
    element.addEventListener("touchmove", function (event) {
      if (element.scrollHeight <= element.clientHeight + 1 || !event.touches || !event.touches.length) return;
      var delta = startY - event.touches[0].clientY;
      if (Math.abs(delta) < 5) return;
      didMove = true;
      element.scrollTop = startTop + delta;
      event.preventDefault();
      event.stopPropagation();
    }, { passive: false });
    element.addEventListener("click", function (event) {
      if (!didMove) return;
      didMove = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }

  function enhanceFinderMakeSelect(root, makes) {
    var select = root.querySelector("[data-tps-make]");
    if (!select || select.getAttribute("data-tps-enhanced") === "1") return;
    var label = select.closest("label");
    if (!label) return;
    select.setAttribute("data-tps-enhanced", "1");
    select.setAttribute("aria-hidden", "true");
    select.tabIndex = -1;
    label.classList.add("tps-finder-make-label");

    var box = document.createElement("span");
    box.className = "tps-finder-select";
    var button = document.createElement("button");
    button.type = "button";
    button.className = "tps-finder-select__button";
    button.setAttribute("aria-haspopup", "listbox");
    button.setAttribute("aria-expanded", "false");
    var menu = document.createElement("span");
    menu.className = "tps-finder-select__menu";
    menu.setAttribute("role", "listbox");
    menu.setAttribute("aria-label", "Kies merk");
    enableTouchScrollbox(menu);

    function syncButton() {
      var make = makes.find(function (row) {
        return row.name === select.value;
      });
      button.textContent = make ? makeLabel(make) : "Kies merk";
      menu.querySelectorAll("[data-tps-make-choice]").forEach(function (option) {
        option.classList.toggle("is-active", option.getAttribute("data-tps-make-choice") === select.value);
      });
    }

    function close() {
      box.classList.remove("is-open");
      button.setAttribute("aria-expanded", "false");
    }

    function open() {
      var rect = button.getBoundingClientRect();
      var roomBelow = Math.max(96, window.innerHeight - rect.bottom - 14);
      menu.style.maxHeight = Math.min(320, roomBelow) + "px";
      box.classList.add("is-open");
      button.setAttribute("aria-expanded", "true");
    }

    makes.forEach(function (make) {
      var option = document.createElement("button");
      option.type = "button";
      option.className = "tps-finder-select__option";
      option.setAttribute("role", "option");
      option.setAttribute("data-tps-make-choice", make.name);
      option.textContent = makeLabel(make) + " (" + (make.count || 0) + ")";
      option.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        select.value = make.name;
        select.dispatchEvent(new Event("change", { bubbles: true }));
        syncButton();
        close();
      });
      menu.appendChild(option);
    });

    button.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      box.classList.contains("is-open") ? close() : open();
    });
    select.addEventListener("change", syncButton);
    document.addEventListener("click", function (event) {
      if (!box.contains(event.target)) close();
    });
    window.addEventListener("resize", close);

    box.appendChild(button);
    box.appendChild(menu);
    select.insertAdjacentElement("afterend", box);
    syncButton();
  }

  function renderFinder(root) {
    var payload = modelsPayload();
    var makes = (payload.makes || []).slice().sort(function (a, b) {
      return alphaCompare(a, b, "name");
    });
    root.innerHTML =
      '<header class="tps-scooter-page__hero tps-scooter-page__hero--finder">' +
      '<div class="tps-hero-copy"><p class="tps-eyebrow">Scooter onderdelen</p>' +
      "<h1>Vind onderdelen voor jouw scooter</h1>" +
      '<p class="tps-scooter-page__intro">Selecteer een merk of kies direct een model.</p></div>' +
      '<div class="tps-finder-shell">' +
      '<div class="tps-finder-picker">' +
      '<div class="tps-finder-search"><button type="button" class="tps-finder-mobile-back" data-tps-finder-close aria-label="Terug">Terug</button><label><span>Zoek merk of model</span><input type="search" data-tps-finder-search autocomplete="off" placeholder="Bijv. Puch, Tomos A35 of Aprilia SR" aria-controls="tps-finder-results" aria-expanded="false"><button type="button" class="tps-finder-clear" data-tps-finder-clear aria-label="Zoektekst wissen" hidden>Wissen</button></label></div>' +
      '<aside class="tps-finder-results" id="tps-finder-results" data-tps-finder-results hidden aria-hidden="true"></aside>' +
      '<div class="tps-finder-controls">' +
      '<label>Merk<select data-tps-make><option value="">Kies merk</option>' +
      makes
        .map(function (make) {
          return '<option value="' + escapeHtml(make.name) + '">' + escapeHtml(makeLabel(make)) + " (" + make.count + ")</option>";
        })
        .join("") +
      "</select></label>" +
      '<label>Model<select data-tps-model disabled><option value="">Kies eerst merk</option></select></label>' +
      '<button type="button" data-tps-go disabled>Bekijk onderdelen</button>' +
      "</div>" +
      "</div>" +
      "</div></header>" +
      '<section class="tps-popular-models"><div class="tps-section-head"><h2>Scooter modellen per merk</h2><p>Kies je merk en model.</p></div>' +
      makes
        .slice(0, MAKE_SECTION_LIMIT)
        .map(function (make) {
          var makeModels = (make.models || []).slice().sort(function (a, b) {
            return alphaCompare(a, b, "model");
          });
          return (
            '<section class="tps-make-section"><h2>' +
            '<a href="' +
            pageUrlForMake(make) +
            '">' +
            escapeHtml(makeLabel(make)) +
            "</a>" +
            "</h2>" +
            '<div class="tps-model-grid">' +
            '<a class="tps-model-link tps-model-link--make" href="' +
            pageUrlForMake(make) +
            '"><strong>Alle ' +
            escapeHtml(makeLabel(make)) +
            "</strong><span>" +
            countLabel(make.count, "artikel", "artikelen") +
            "</span></a>" +
            makeModels
              .slice(0, MODEL_SECTION_LIMIT)
              .map(function (model) {
                return (
                  '<a class="tps-model-link" href="' +
                  pageUrlForModel(model) +
                  '"><strong>' +
                  escapeHtml(model.model) +
                  "</strong><span>" +
                  countLabel(model.count, "artikel", "artikelen") +
                  "</span></a>"
                );
              })
              .join("") +
            "</div></section>"
          );
        })
        .join("") +
      "</section>";

    var makeSelect = root.querySelector("[data-tps-make]");
    var modelSelect = root.querySelector("[data-tps-model]");
    var finderSearch = root.querySelector("[data-tps-finder-search]");
    var finderClose = root.querySelector("[data-tps-finder-close]");
    var finderClear = root.querySelector("[data-tps-finder-clear]");
    var go = root.querySelector("[data-tps-go]");
    closeFinderResults(root);
    makeSelect.addEventListener("change", function () {
      var make = makes.find(function (row) {
        return row.name === makeSelect.value;
      });
      var rows = make
        ? (make.models || []).slice().sort(function (a, b) {
            return alphaCompare(a, b, "model");
          })
        : [];
      modelSelect.innerHTML =
        '<option value="">' +
        (make ? "Alle " + escapeHtml(makeLabel(make)) + " onderdelen" : "Kies model") +
        "</option>" +
        rows
          .map(function (row) {
            return '<option value="' + escapeHtml(row.slug) + '">' + escapeHtml(row.model) + " (" + row.count + ")</option>";
          })
          .join("");
      modelSelect.disabled = !rows.length;
      go.disabled = !make;
    });
    modelSelect.addEventListener("change", function () {
      go.disabled = !makeSelect.value && !modelSelect.value;
    });
    enhanceFinderMakeSelect(root, makes);
    function syncFinderClear() {
      if (finderClear) finderClear.hidden = !finderSearch.value.trim();
    }
    finderSearch.addEventListener("input", function () {
      syncFinderClear();
      renderFinderResults(root, makes);
    });
    finderSearch.addEventListener("focus", function () {
      syncFinderClear();
      if (finderSearch.value.trim()) renderFinderResults(root, makes);
    });
    finderSearch.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeFinderResults(root);
    });
    finderSearch.addEventListener("blur", function () {
      if (isMobileViewport()) return;
      window.setTimeout(function () {
        closeFinderResults(root);
      }, 160);
    });
    if (finderClose) {
      finderClose.addEventListener("click", function (event) {
        event.preventDefault();
        closeFinderResults(root);
        if (finderSearch) finderSearch.blur();
      });
    }
    if (finderClear) {
      finderClear.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        finderSearch.value = "";
        syncFinderClear();
        closeFinderResults(root);
        finderSearch.focus();
      });
    }
    go.addEventListener("click", function () {
      if (modelSelect.value) {
        window.location.href = "/pages/scooter-" + modelSelect.value;
        return;
      }
      var make = makes.find(function (row) {
        return row.name === makeSelect.value;
      });
      if (make) window.location.href = pageUrlForMake(make);
    });
  }

  function imageUrlWithWidth(url, width) {
    if (!url) return "";
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set("width", String(width));
      return parsed.toString();
    } catch (error) {
      return url + (url.indexOf("?") >= 0 ? "&" : "?") + "width=" + width;
    }
  }

  function productImageMarkup(product, title, index) {
    if (!product.imageUrl) return "";
    var eager = index < 8;
    var src = imageUrlWithWidth(product.imageUrl, 430);
    var srcset = [240, 350, 430, 533]
      .map(function (width) {
        return imageUrlWithWidth(product.imageUrl, width) + " " + width + "w";
      })
      .join(",");
    return (
      '<picture><img src="' +
      escapeHtml(src) +
      '" srcset="' +
      escapeHtml(srcset) +
      '" sizes="(min-width: 1300px) 170px, (min-width: 1000px) calc((100vw - 360px) / 5), 50vw" alt="' +
      escapeHtml(title) +
      '" loading="' +
      (eager ? "eager" : "lazy") +
      '" decoding="async"' +
      (index < 4 ? ' fetchpriority="high"' : "") +
      ' width="430" height="430"></picture>'
    );
  }

  function productCard(product, index) {
    var title = product.title || product.sku || "";
    var url = product.url || "/search?type=product&q=" + encodeURIComponent(product.sku || title);
    var image = productImageMarkup(product, title, index || 0);
    var price = formatPrice(product.price).replace("\u20ac ", "\u20ac");
    var variantId = product.variantId || "";
    var handle = product.handle || productHandleFromUrl(url);
    return (
      '<li class="product-card has-form second-img-hover tps-theme-product-card' +
      (product.available ? "" : " unavailable") +
      '" data-tps-live-card data-variant-id="' +
      escapeHtml(variantId) +
      '" data-product-handle="' +
      escapeHtml(handle) +
      '">' +
      '<figure class="img-multiply"><span class="s1lb label plain"></span><a href="' +
      escapeHtml(url) +
      '" aria-label="' +
      escapeHtml(title) +
      '">' +
      image +
      "</a></figure>" +
      '<div><h3 class="p0"><a href="' +
      escapeHtml(url) +
      '">' +
      escapeHtml(title) +
      '</a></h3><input type="hidden" name="id" value="' +
      escapeHtml(variantId) +
      '">' +
      '<p class="stock tps-live-stock is-loading" data-tps-live-stock><span>Voorraad laden...</span></p>' +
      '</div><div class="static">' +
      (price ? '<p class="price s1pr" data-tps-live-price>' + escapeHtml(price) + "</p>" : '<p class="price s1pr" data-tps-live-price></p>') +
      "</div></li>"
    );
  }

  function applyLiveVariantToCard(card, row) {
    if (!card || !row) return;
    var stock = card.querySelector("[data-tps-live-stock]");
    var priceNode = card.querySelector("[data-tps-live-price]");
    var stockState = liveStockLabel(row);
    card.classList.toggle("unavailable", !row.available);
    if (stock) {
      stock.classList.remove("is-loading", "is-in", "is-low", "is-out", "is-neutral");
      stock.classList.add(stockState.className || "is-neutral");
      stock.innerHTML =
        stockState.text && row.available
          ? '<span><i aria-hidden="true" class="icon-check"></i>' + escapeHtml(stockState.text) + "</span>"
          : "<span>" + escapeHtml(stockState.text || "Niet op voorraad") + "</span>";
    }
    var price = livePriceText(row);
    if (priceNode && price) priceNode.textContent = price;
    card.setAttribute("data-tps-live-hydrated", "1");
  }

  function liveRowFromProductJson(product, variantId) {
    var variants = (product && product.variants) || [];
    var variant =
      variants.find(function (row) {
        return String(row.id || "") === String(variantId || "");
      }) || variants[0];
    if (!variant) return null;
    return {
      variantId: String(variant.id || variantId || ""),
      price: { cents: Number(variant.price || product.price || 0) },
      available: Boolean(variant.available),
      availableQuantity: null,
    };
  }

  function fetchProductJsonFallback(cards) {
    cards.forEach(function (card) {
      var handle = card.getAttribute("data-product-handle") || "";
      var variantId = card.getAttribute("data-variant-id") || "";
      if (!handle) return;
      fetch("/products/" + encodeURIComponent(handle) + ".js", { headers: { Accept: "application/json" } })
        .then(function (response) {
          if (!response.ok) throw new Error("Product JSON niet beschikbaar");
          return response.json();
        })
        .then(function (product) {
          var row = liveRowFromProductJson(product, variantId);
          if (row) applyLiveVariantToCard(card, row);
        })
        .catch(function () {
          var stock = card.querySelector("[data-tps-live-stock]");
          if (stock) {
            stock.classList.remove("is-loading");
            stock.innerHTML = "";
          }
        });
    });
  }

  function hydrateLiveProductCards(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-tps-live-card]")).filter(function (card) {
      return card.getAttribute("data-tps-live-hydrated") !== "1" && card.getAttribute("data-tps-live-pending") !== "1";
    });
    if (!cards.length) return;
    var ids = [];
    var cardsById = {};
    cards.forEach(function (card) {
      var variantId = card.getAttribute("data-variant-id") || "";
      if (!variantId) return;
      cardsById[variantId] = cardsById[variantId] || [];
      cardsById[variantId].push(card);
      if (liveVariantCache[variantId]) {
        applyLiveVariantToCard(card, liveVariantCache[variantId]);
      } else if (!liveVariantPending[variantId]) {
        ids.push(variantId);
      }
    });
    ids = ids.filter(function (id, index) {
      return ids.indexOf(id) === index;
    });
    if (!ids.length) return;
    ids.forEach(function (id) {
      liveVariantPending[id] = true;
      (cardsById[id] || []).forEach(function (card) {
        card.setAttribute("data-tps-live-pending", "1");
      });
    });
    fetch(LIVE_VARIANT_ENDPOINT + "?ids=" + encodeURIComponent(ids.join(",")), {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Live voorraad niet beschikbaar");
        return response.json();
      })
      .then(function (payload) {
        var variants = (payload && payload.variants) || {};
        ids.forEach(function (id) {
          delete liveVariantPending[id];
          var row = variants[id];
          if (row) liveVariantCache[id] = row;
          (cardsById[id] || []).forEach(function (card) {
            card.removeAttribute("data-tps-live-pending");
            if (row) applyLiveVariantToCard(card, row);
          });
        });
        var missingCards = cards.filter(function (card) {
          return card.getAttribute("data-tps-live-hydrated") !== "1";
        });
        if (missingCards.length) fetchProductJsonFallback(missingCards);
      })
      .catch(function () {
        ids.forEach(function (id) {
          delete liveVariantPending[id];
          (cardsById[id] || []).forEach(function (card) {
            card.removeAttribute("data-tps-live-pending");
          });
        });
        fetchProductJsonFallback(cards);
      });
  }

  function bindAddToCart(root) {
    root.querySelectorAll("[data-tps-add-to-cart]").forEach(function (button) {
      if (button.getAttribute("data-bound") === "1") return;
      button.setAttribute("data-bound", "1");
      button.addEventListener("click", function () {
        var variantId = button.getAttribute("data-variant-id");
        if (!variantId) return;
        var oldText = button.textContent;
        button.disabled = true;
        button.textContent = "Toevoegen...";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        })
          .then(function (response) {
            if (!response.ok) throw new Error("Kon niet toevoegen");
            return response.json();
          })
          .then(function () {
            button.textContent = "Toegevoegd";
            document.dispatchEvent(new CustomEvent("cart:refresh"));
            document.dispatchEvent(new CustomEvent("cart:updated"));
            window.dispatchEvent(new CustomEvent("cart:updated"));
            setTimeout(function () {
              button.disabled = false;
              button.textContent = oldText;
            }, 1800);
          })
          .catch(function () {
            window.location.href = "/cart/add?id=" + encodeURIComponent(variantId) + "&quantity=1";
          });
      });
    });
  }

  function paginationUrl(basePath, page, state) {
    return modelUrl(basePath, {
      categories: state.categories,
      searchQuery: state.searchQuery,
      inStock: state.inStock,
      sort: state.sort,
      page: page,
    });
  }

  function activeCategoryHtml(basePath, categories, searchQuery, inStock, sort) {
    var selected = normalizeCategoryList(categories);
    var items = [];
    if (inStock) {
      items.push(
        '<a class="tps-active-filter-clear" href="' +
          stockUrl(basePath, selected, searchQuery, true, sort) +
          '" data-tps-model-nav data-tps-clear-category>Op voorraad verwijderen</a>'
      );
    }
    selected.forEach(function (category) {
      items.push(
        '<a class="tps-active-filter-clear" href="' +
          categoryUrl(basePath, selected, category, searchQuery, inStock, sort) +
          '" data-tps-model-nav data-tps-clear-category>' +
          escapeHtml(category) +
          " verwijderen</a>"
      );
    });
    if (!items.length) return "";
    return (
      '<span>Actieve filters:</span>' +
      items.join("") +
      '<a class="tps-active-filter-clear" href="' +
      clearFiltersUrl(basePath, searchQuery, sort) +
      '" data-tps-model-nav data-tps-clear-category>Alles wissen</a>'
    );
  }

  function activeFilterLabel(categoryData, category) {
    var groups = (categoryData && categoryData.categoryGroups) || [];
    for (var index = 0; index < groups.length; index += 1) {
      var group = groups[index];
      if (group.name === category) return "Categorie";
      if (
        (group.children || []).some(function (child) {
          return child.name === category;
        })
      ) {
        return group.name;
      }
    }
    return "Onderdeelsoort";
  }

  function activeFilterListHtml(basePath, categories, searchQuery, inStock, sort, categoryData) {
    var selected = normalizeCategoryList(categories);
    var rows = [];
    if (inStock) {
      rows.push(
        '<li><label for="Filter-filter.v.availability-1"><a href="' +
          stockUrl(basePath, selected, searchQuery, true, sort) +
          '" class="no-click" data-tps-model-nav><span class="tps-filter-label">Beschikbaarheid</span><span class="tps-filter-value">Op voorraad</span></a></label></li>'
      );
    }
    selected.forEach(function (category) {
      rows.push(
        '<li><label for="' +
          escapeHtml(filterId(category)) +
          '"><a href="' +
          categoryUrl(basePath, selected, category, searchQuery, inStock, sort) +
          '" class="no-click" data-tps-model-nav><span class="tps-filter-label">Categorie</span><span class="tps-filter-value">' +
          escapeHtml(category) +
          "</span></a></label></li>"
      );
    });
    if (!rows.length) return "";
    rows.push(
      '<li class="strong"><a href="' +
        clearFiltersUrl(basePath, searchQuery, sort) +
        '" class="remove-all" data-tps-model-nav>Verwijder alle filters</a></li>'
    );
    return rows.join("");
  }

  function filterId(value) {
    return "Filter-filter.p.t.category-" + String(value || "alles").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }

  function groupHasActiveSelection(group, categories) {
    if (categorySelected(categories, group.name)) return true;
    return (group.children || []).some(function (child) {
      return categorySelected(categories, child.name);
    });
  }

  function nativeGroupHeader(id, label, open) {
    return (
      '<h4 data-filter-toggle="' +
      escapeHtml(id) +
      '" class="tps-native-filter-title' +
      (open ? " is-open" : "") +
      '"><a href="./" class="tps-native-filter-toggle" data-tps-native-toggle aria-expanded="' +
      (open ? "true" : "false") +
      '" aria-controls="' +
      escapeHtml(id) +
      '-list"><span>' +
      escapeHtml(label) +
      '</span><i aria-hidden="true" class="arrows_bv arrow down tps-native-filter-arrow"></i></a></h4>'
    );
  }

  function nativeCategoryOption(basePath, item, categories, searchQuery, inStock, sort, child) {
    var active = categorySelected(categories, item.name);
    var id = filterId(item.name);
    var className = "tps-category " + (child ? "tps-category--child" : "tps-category--parent") + (active ? " is-active" : "");
    return (
      '<li><input type="checkbox" name="categorie" value="' +
      escapeHtml(item.name) +
      '" id="' +
      escapeHtml(id) +
      '"' +
      (active ? " checked" : "") +
      '><label for="' +
      escapeHtml(id) +
      '" class="align-middle"><a href="' +
      categoryUrl(basePath, categories, item.name, searchQuery, inStock, sort) +
      '" class="' +
      className +
      '" data-tps-model-nav><span>' +
      escapeHtml(item.name) +
      " <span>(" +
      item.count +
      ")</span></span></a></label></li>"
    );
  }

  function shouldHideParentCategory(group, children) {
    if (!children || children.length !== 1) return false;
    return Number(children[0].count || 0) === Number(group.count || 0);
  }

  function nativeAvailabilityOption(basePath, categories, searchQuery, inStock, sort, count) {
    var id = "Filter-filter.v.availability-1";
    return (
      '<li><input type="checkbox" name="op_voorraad" value="1" id="' +
      id +
      '"' +
      (inStock ? " checked" : "") +
      '><label for="' +
      id +
      '" class="strong"><a href="' +
      stockUrl(basePath, categories, searchQuery, inStock, sort) +
      '" class="tps-category tps-category--availability' +
      (inStock ? " is-active" : "") +
      '" data-tps-model-nav><span>Op voorraad <span>(' +
      count +
      ")</span></span></a></label></li>"
    );
  }

  function groupToggle(group, open) {
    var children = group.children || [];
    if (!children.length) return "";
    return (
      '<button type="button" class="tps-filter-group-toggle" data-tps-toggle-group aria-expanded="' +
      (open ? "true" : "false") +
      '" aria-label="Subcategorieen tonen of verbergen"><span>' +
      (open ? "-" : "+") +
      "</span></button>"
    );
  }

  function renderCategoryFilters(data, categories, basePath, searchQuery, inStock, sort, availableCount) {
    var groups = data.categoryGroups || [];
    if (groups.length) {
      return (
        nativeGroupHeader("TPS-filter-availability", "Beschikbaarheid", true) +
        '<ul class="check is-open" id="TPS-filter-availability-list" data-filter-toggle="TPS-filter-availability">' +
        nativeAvailabilityOption(basePath, categories, searchQuery, inStock, sort, availableCount) +
        "</ul>" +
        groups
          .map(function (group) {
            var id = filterId(group.name);
            var isOpenGroup = groupHasActiveSelection(group, categories);
            var children = (group.children || [])
              .map(function (child) {
                return nativeCategoryOption(basePath, child, categories, searchQuery, inStock, sort, true);
              })
              .join("");
            var childRows = group.children || [];
            var parent = shouldHideParentCategory(group, childRows)
              ? ""
              : nativeCategoryOption(basePath, group, categories, searchQuery, inStock, sort, false);
            return (
              nativeGroupHeader(id, group.name, isOpenGroup) +
              '<ul class="check' +
              (isOpenGroup ? " is-open" : " is-collapsed") +
              '" id="' +
              escapeHtml(id) +
              '-list" data-filter-toggle="' +
              escapeHtml(id) +
              '">' +
              parent +
              children +
              "</ul>"
            );
          })
          .join("")
      );
    }
    return (
      nativeGroupHeader("TPS-filter-availability", "Beschikbaarheid", true) +
      '<ul class="check is-open" id="TPS-filter-availability-list" data-filter-toggle="TPS-filter-availability">' +
      nativeAvailabilityOption(basePath, categories, searchQuery, inStock, sort, availableCount) +
      "</ul>" +
      nativeGroupHeader("TPS-filter-category-overig", "Onderdeelsoort", false) +
      '<ul class="check is-collapsed" id="TPS-filter-category-overig-list" data-filter-toggle="TPS-filter-category-overig">' +
      (data.categories || [])
        .map(function (item) {
          return nativeCategoryOption(basePath, item, categories, searchQuery, inStock, sort, true);
        })
        .join("") +
      "</ul>"
    );
  }

  function toggleCategoryGroup(button) {
    if (button.hasAttribute("data-tps-native-toggle")) {
      var controls = button.getAttribute("aria-controls");
      var list = controls ? document.getElementById(controls) : null;
      if (!list) {
        var heading = button.closest("h4");
        list = heading && heading.nextElementSibling && heading.nextElementSibling.matches("ul.check") ? heading.nextElementSibling : null;
      }
      if (!list) return;
      var nativeOpen = list.classList.toggle("is-collapsed") ? false : true;
      list.classList.toggle("is-open", nativeOpen);
      button.setAttribute("aria-expanded", nativeOpen ? "true" : "false");
      var icon = button.querySelector("i");
      if (icon) {
        icon.textContent = "";
        icon.className = "arrows_bv arrow down tps-native-filter-arrow";
      }
      var nativeHeading = button.closest("h4");
      if (nativeHeading) nativeHeading.classList.toggle("is-open", nativeOpen);
      return;
    }
    var group = button.closest(".tps-filter-group");
    if (!group) return;
    var open = group.classList.toggle("is-open");
    button.setAttribute("aria-expanded", open ? "true" : "false");
    var label = button.querySelector("span");
    if (label) label.textContent = open ? "-" : "+";
  }

  function bindCategoryGroups(root) {
    root.querySelectorAll("[data-tps-toggle-group], [data-tps-native-toggle]").forEach(function (button) {
      if (button.getAttribute("data-bound") === "1") return;
      button.setAttribute("data-bound", "1");
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggleCategoryGroup(button);
      });
    });
  }

  function modelStateFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var categories = normalizeCategoryList(params.getAll("categorie"));
    return {
      categories: categories,
      category: categories[0] || "",
      searchQuery: params.get("zoek") || "",
      inStock: params.get("op_voorraad") === "1",
      sort: normalizeSort(params.get("sort_by")),
      page: Math.max(1, Number(params.get("pagina") || "1")),
    };
  }

  function writeModelStateUrl(basePath, state, replace) {
    var url = modelUrl(basePath, state);
    if (replace) window.history.replaceState(null, "", url);
    else window.history.pushState(null, "", url);
  }

  function closeMobileFilter(root) {
    root.classList.remove("is-mobile-filter-open");
    document.body.classList.remove("tps-mobile-filter-active");
    document.documentElement.classList.remove("tps-mobile-filter-active");
    var openButton = root.querySelector("[data-tps-open-mobile-filters]");
    if (openButton) openButton.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  }

  function scrollModelTop(root) {
    var target = root.querySelector(".tps-native-head") || root.querySelector(".tps-model-header") || root;
    window.requestAnimationFrame(function () {
      var top = target.getBoundingClientRect().top + window.pageYOffset - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    });
  }

  function bindModelSearch(root, data, basePath) {
    var form = root.querySelector("[data-tps-model-search]");
    if (!form || form.getAttribute("data-bound") === "1") return;
    form.setAttribute("data-bound", "1");
    var input = form.querySelector("[data-tps-model-search-input]");
    var timer = null;
    form.addEventListener("submit", function (event) {
      event.preventDefault();
    });
    if (!input) return;
    input.addEventListener("keydown", function (event) {
      if (event.key === "Enter") event.preventDefault();
    });
    input.addEventListener("input", function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        var state = modelStateFromUrl();
        state.searchQuery = input.value;
        state.page = 1;
        writeModelStateUrl(basePath, state, true);
        renderModelState(root, data, basePath, state);
      }, 90);
    });
  }

  function bindCollectionToolbar(root, data, basePath) {
    var toolbar = root.querySelector(".tps-native-toolbar-form");
    if (toolbar && toolbar.getAttribute("data-bound") !== "1") {
      toolbar.setAttribute("data-bound", "1");
      toolbar.addEventListener("submit", function (event) {
        event.preventDefault();
      });
      toolbar.addEventListener("click", function (event) {
        var current = event.target.closest("[data-tps-sort-current]");
        if (current && toolbar.contains(current)) {
          event.preventDefault();
          var box = current.closest("[data-tps-sort-box]");
          var open = box && !box.classList.contains("is-open");
          root.querySelectorAll("[data-tps-sort-box].is-open").forEach(function (item) {
            if (item !== box) item.classList.remove("is-open");
          });
          if (box) box.classList.toggle("is-open", open);
          current.setAttribute("aria-expanded", open ? "true" : "false");
          return;
        }

        var choice = event.target.closest("[data-tps-sort-choice]");
        if (!choice || !toolbar.contains(choice)) return;
        var value = normalizeSort(choice.getAttribute("data-tps-sort-choice"));
        event.preventDefault();
        var choiceBox = choice.closest("[data-tps-sort-box]");
        if (choiceBox) choiceBox.classList.remove("is-open");
        var state = modelStateFromUrl();
        state.sort = value;
        state.page = 1;
        writeModelStateUrl(basePath, state, false);
        renderModelState(root, data, basePath, state);
      });
      document.addEventListener("click", function (event) {
        if (toolbar.contains(event.target)) return;
        root.querySelectorAll("[data-tps-sort-box].is-open").forEach(function (box) {
          box.classList.remove("is-open");
          var current = box.querySelector("[data-tps-sort-current]");
          if (current) current.setAttribute("aria-expanded", "false");
        });
      });
    }

    root.querySelectorAll("[data-width]").forEach(function (input) {
      if (input.getAttribute("data-bound") === "1") return;
      input.setAttribute("data-bound", "1");
      input.addEventListener("change", function () {
        var grid = root.querySelector("[data-tps-product-grid]");
        if (!grid || !input.checked) return;
        grid.classList.remove("w20", "w25");
        grid.classList.add(input.getAttribute("data-width") || "w20");
      });
    });

    root.querySelectorAll("[data-tps-display]").forEach(function (link) {
      if (link.getAttribute("data-bound") === "1") return;
      link.setAttribute("data-bound", "1");
      link.addEventListener("click", function (event) {
        event.preventDefault();
        var list = link.getAttribute("data-tps-display") === "list";
        var grid = root.querySelector("[data-tps-product-grid]");
        root.classList.toggle("is-list-display", list);
        if (grid) grid.classList.toggle("list", list);
        root.querySelectorAll("[data-tps-display]").forEach(function (item) {
          var li = item.closest("li");
          if (li) li.classList.toggle("active", item === link);
        });
      });
    });
  }

  function bindModelNavigation(root, data, basePath) {
    if (root.getAttribute("data-model-nav-bound") === "1") return;
    root.setAttribute("data-model-nav-bound", "1");
    root.addEventListener("click", function (event) {
      var toggle = event.target.closest("[data-tps-toggle-group], [data-tps-native-toggle]");
      if (toggle && root.contains(toggle)) {
        event.preventDefault();
        event.stopPropagation();
        toggleCategoryGroup(toggle);
        return;
      }

      var clear = event.target.closest("[data-tps-clear-search]");
      if (clear && root.contains(clear)) {
        event.preventDefault();
        var input = root.querySelector("[data-tps-model-search-input]");
        var state = modelStateFromUrl();
        state.searchQuery = "";
        state.page = 1;
        if (input) input.value = "";
        writeModelStateUrl(basePath, state, true);
        renderModelState(root, data, basePath, state);
        if (input) input.focus();
        return;
      }

      var nativeInput = event.target.closest(".tps-native-fieldset input[type='checkbox'], .tps-native-fieldset label");
      if (nativeInput && root.contains(nativeInput)) {
        var nativeRow = nativeInput.closest("li");
        var nativeLink = nativeRow && nativeRow.querySelector("a[data-tps-model-nav]");
        if (nativeLink && !(event.target.closest && event.target.closest("a[data-tps-model-nav]"))) {
          event.preventDefault();
          event.stopPropagation();
          nativeLink.click();
          return;
        }
      }

      var link = event.target.closest("[data-tps-model-nav]");
      if (!link || !root.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      var shouldScrollTop = link.classList.contains("tps-page-link");
      var shouldCloseMobileFilter = link.hasAttribute("data-tps-close-after-nav");
      var url = new URL(link.href, window.location.origin);
      window.history.pushState(null, "", url.pathname + url.search);
      renderModelState(root, data, basePath, modelStateFromUrl());
      if (shouldScrollTop) scrollModelTop(root);
      if (shouldCloseMobileFilter) closeMobileFilter(root);
    });
    window.addEventListener("popstate", function () {
      renderModelState(root, data, basePath, modelStateFromUrl());
    });
  }

  function bindMobileFilterDrawer(root) {
    var openButton = root.querySelector("[data-tps-open-mobile-filters]");
    var closeButtons = root.querySelectorAll("[data-tps-close-mobile-filters]");
    if (!openButton || openButton.getAttribute("data-bound") === "1") return;
    openButton.setAttribute("data-bound", "1");

    function setOpen(open) {
      root.classList.toggle("is-mobile-filter-open", open);
      document.body.classList.toggle("tps-mobile-filter-active", open);
      document.documentElement.classList.toggle("tps-mobile-filter-active", open);
      openButton.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.style.overflow = open ? "hidden" : "";
      if (open) {
        window.requestAnimationFrame(function () {
          var filter = root.querySelector(".tps-native-filter");
          var fieldset = root.querySelector(".tps-native-filter .tps-native-fieldset");
          if (filter) filter.scrollTop = 0;
          if (fieldset) fieldset.scrollTop = 0;
        });
      }
    }

    openButton.addEventListener("click", function (event) {
      event.preventDefault();
      setOpen(true);
    });
    closeButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        setOpen(false);
      });
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && root.classList.contains("is-mobile-filter-open")) {
        setOpen(false);
      }
    });
  }

  function setImportantStyle(node, property, value) {
    if (!node) return;
    if (value === null) node.style.removeProperty(property);
    else node.style.setProperty(property, value, "important");
  }

  function applyNativeMobileWidth(root) {
    var mobile = window.matchMedia("(max-width: 1000px)").matches;
    var wrapper = root.querySelector(".tps-native-collection-wrapper");
    var results = root.querySelector(".tps-native-results");
    var toolbar = root.querySelector(".tps-native-toolbar-form");
    var collection = root.querySelector("#collection");
    [root, wrapper, results, toolbar, collection].forEach(function (node) {
      setImportantStyle(node, "box-sizing", mobile ? "border-box" : null);
      setImportantStyle(node, "max-width", mobile ? "100%" : null);
      setImportantStyle(node, "width", mobile ? "100%" : null);
      setImportantStyle(node, "min-width", mobile ? "0" : null);
    });
    setImportantStyle(root, "background", mobile ? "#fff" : null);
    setImportantStyle(root, "max-width", mobile ? "100vw" : null);
    setImportantStyle(root, "width", mobile ? "100vw" : null);
    setImportantStyle(root, "margin-left", mobile ? "calc(50% - 50vw)" : null);
    setImportantStyle(root, "margin-right", mobile ? "calc(50% - 50vw)" : null);
    setImportantStyle(root, "padding-left", mobile ? "0" : null);
    setImportantStyle(root, "padding-right", mobile ? "0" : null);
    setImportantStyle(wrapper, "display", mobile ? "block" : null);
    setImportantStyle(wrapper, "grid-template-columns", mobile ? "1fr" : null);
    setImportantStyle(wrapper, "margin-left", mobile ? "0" : null);
    setImportantStyle(wrapper, "margin-right", mobile ? "0" : null);
    setImportantStyle(wrapper, "padding-left", mobile ? "16px" : null);
    setImportantStyle(wrapper, "padding-right", mobile ? "16px" : null);
    setImportantStyle(results, "display", mobile ? "block" : null);
    setImportantStyle(results, "max-width", mobile ? "none" : null);
    setImportantStyle(results, "padding-left", mobile ? "0" : null);
    setImportantStyle(collection, "margin-left", mobile ? "-16px" : null);
    setImportantStyle(collection, "max-width", mobile ? "none" : null);
    setImportantStyle(collection, "width", mobile ? "calc(100% + 16px)" : null);
    setImportantStyle(collection, "padding-left", mobile ? "0" : null);
  }

  function bindNativeMobileWidth(root) {
    if (root.getAttribute("data-tps-mobile-width-bound") === "1") return;
    root.setAttribute("data-tps-mobile-width-bound", "1");
    window.addEventListener("resize", function () {
      applyNativeMobileWidth(root);
    });
  }

  function renderModelState(root, data, basePath, state) {
    var categories = normalizeCategoryList(state.categories || state.category);
    var searchQuery = state.searchQuery || "";
    var inStock = Boolean(state.inStock);
    var sort = normalizeSort(state.sort);
    var tokens = searchTokens(searchQuery);
    var page = Math.max(1, Number(state.page || 1));
    var searchedProducts = searchProducts(data.products || [], tokens);
    var availableCount = searchedProducts.filter(function (product) {
      return Boolean(product.available);
    }).length;
    var availabilityProducts = inStock
      ? searchedProducts.filter(function (product) {
          return Boolean(product.available);
        })
      : searchedProducts;
    var categoryData = categoryDataFromProducts(availabilityProducts);
    var products = availabilityProducts.filter(function (product) {
      if (!categories.length) return true;
      return categories.some(function (category) {
        return (product.categories || []).indexOf(category) >= 0;
      });
    });
    products = sortProducts(products, sort);
    var totalPages = Math.max(1, Math.ceil(products.length / PAGE_SIZE));
    if (page > totalPages) page = totalPages;
    var visible = products.slice(0, page * PAGE_SIZE);
    var start = visible.length ? 1 : 0;
    var end = visible.length;
    var stateForLinks = { categories: categories, searchQuery: searchQuery, inStock: inStock, sort: sort };
    var categoryLinks = renderCategoryFilters(categoryData, categories, basePath, searchQuery, inStock, sort, availableCount);
    var shownPercentage = products.length ? (end / products.length) * 100 : 0;
    var loadMore =
      page < totalPages
        ? '<p class="link-btn text-center"><a id="load-more-button" href="' +
          paginationUrl(basePath, page + 1, stateForLinks) +
          '" data-section="tps-scooter-fitment" data-next data-tps-model-nav data-tps-load-more>Toon meer producten</a></p>'
        : "";
    var searchNote = searchQuery ? " voor " + escapeHtml(searchQuery) : "";
    var activeLabels = categories.slice();
    if (inStock) activeLabels.unshift("Op voorraad");
    var mobileFilterLabel = activeLabels.length ? "Filters: " + escapeHtml(activeLabels.join(", ")) : "Filters";
    var activeCategory = activeCategoryHtml(basePath, categories, searchQuery, inStock, sort);
    var activeFilterList = activeFilterListHtml(basePath, categories, searchQuery, inStock, sort, categoryData);
    var hasActiveFilters = Boolean(activeFilterList);
    root.classList.toggle("has-active-filters", hasActiveFilters);

    var input = root.querySelector("[data-tps-model-search-input]");
    if (input && input.value !== searchQuery) input.value = searchQuery;

    syncSimpleSort(root, sort);

    var summary = root.querySelector("[data-tps-model-summary]");
    setProductCountText(summary, products.length);

    var toolbarCount = root.querySelector("[data-tps-toolbar-count]");
    setProductCountText(toolbarCount, products.length);

    var filterTotal = root.querySelector("[data-tps-filter-total]");
    if (filterTotal) {
      filterTotal.textContent = "(" + products.length + ")";
    }

    root.querySelectorAll("[data-tps-category-list]").forEach(function (list) {
      list.innerHTML = categoryLinks;
    });

    var currentFilters = root.querySelector(".tps-native-current-filters") || root.querySelector("[data-tps-filter-current]");
    if (currentFilters) {
      currentFilters.innerHTML = activeFilterList;
      currentFilters.hidden = !hasActiveFilters;
    }

    root.querySelectorAll("[data-tps-remove-all-filters]").forEach(function (link) {
      link.setAttribute("href", clearFiltersUrl(basePath, searchQuery, sort));
      link.hidden = !hasActiveFilters;
    });

    var mobileActive = root.querySelector("[data-tps-mobile-active-filter]");
    if (mobileActive) {
      mobileActive.innerHTML = activeLabels.length
        ? '<span>' + mobileFilterLabel + '</span><a href="' + clearFiltersUrl(basePath, searchQuery, sort) + '" data-tps-model-nav data-tps-clear-category>Verwijderen</a>'
        : mobileFilterLabel;
    }

    var clearTarget = root.querySelector("[data-tps-search-clear-target]");
    if (clearTarget) {
      clearTarget.innerHTML = searchQuery
        ? '<a class="tps-search-clear" href="' +
          modelUrl(basePath, { categories: categories, searchQuery: "", inStock: inStock, sort: sort, page: 1 }) +
          '" data-tps-clear-search>Zoekopdracht wissen</a>'
        : "";
    }

    var activeTarget = root.querySelector("[data-tps-active-selection]");
    if (activeTarget) {
      activeTarget.innerHTML = activeCategory;
      activeTarget.hidden = !activeCategory;
    }

    var resultsHead = root.querySelector("[data-tps-results-head]");
    if (resultsHead) {
      resultsHead.innerHTML =
        "<p>Toont " +
        start +
        "-" +
        end +
        " van " +
        products.length +
        " artikelen" +
        (searchQuery ? " gevonden" : "") +
        "</p>";
    }

    var grid = root.querySelector("[data-tps-product-grid]");
    if (grid) {
      grid.innerHTML = visible.length ? visible.map(productCard).join("") : "<p>Geen artikelen gevonden binnen deze selectie.</p>";
      hydrateLiveProductCards(root);
    }

    var pagination = root.querySelector("[data-tps-pagination]");
    if (pagination) {
      pagination.innerHTML =
        '<hr class="m25"><div id="load-more-info" class="text-center"><p>Je hebt <span class="strong">' +
        end +
        '</span> van de <span class="strong">' +
        products.length +
        '</span> producten gezien</p><div><p class="s1br m20"><span class="rating-label"><span class="bar" style="width: ' +
        shownPercentage +
        '%"></span></span></p></div></div>' +
        loadMore;
    }

    bindCategoryGroups(root);
    bindAddToCart(root);
    hydrateLiveProductCards(root);
    applyNativeMobileWidth(root);
    normalizeProductCountText(root);
    window.setTimeout(function () {
      normalizeProductCountText(root);
      applyNativeMobileWidth(root);
    }, 250);
  }

  function renderModel(root, data) {
    var state = modelStateFromUrl();
    var basePath = "/pages/scooter-" + data.slug;
    var pageTitle = escapeHtml(data.label + " onderdelen");
    var sortOptions = renderSimpleSortOptions(state.sort);
    root.classList.add("is-native-layout");
    root.innerHTML =
      '<div class="shopify-section shopify-section-breadcrumbs tps-native-breadcrumb-section"><nav class="n6br" role="navigation" aria-label="breadcrumbs"><ol><li><a href="/" title="Home">Homepage</a></li><li><a href="/pages/scooter-onderdelen-op-model">Alle scooter modellen</a></li><li aria-current="page">' +
      pageTitle +
      "</li></ol></nav></div>" +
      '<div class="tps-mobile-filter-backdrop" data-tps-close-mobile-filters></div>' +
      '<div class="collection-wrapper m6cl sticky section-width-boxed tps-native-collection-wrapper">' +
      '<form action="' +
      basePath +
      '" method="get" class="f8fl tps-native-filter" id="filter"><fieldset class="tps-native-fieldset">' +
      '<legend>Filteren</legend><header><h3><span class="desktop-only tps-current-filter-title">Je huidige filters</span><span class="desktop-hide">Filteren</span><a href="' +
      clearFiltersUrl(basePath, state.searchQuery, state.sort) +
      '" class="desktop-hide remove-all" data-tps-model-nav data-tps-remove-all-filters>Verwijder alle filters</a><a class="header-toggle" href="#" aria-label="Sluiten" data-tps-close-mobile-filters><span aria-hidden="true">&times;</span></a></h3><ul class="desktop-only tps-native-current-filters" hidden></ul></header>' +
      '<div data-tps-category-list></div>' +
      '<p class="link-btn submit desktop-hide"><a href="./" aria-controls="filter" data-tps-close-mobile-filters>Toon producten <span data-tps-filter-total></span></a></p>' +
      "</fieldset></form>" +
      '<main class="tps-native-results">' +
      '<header class="tps-native-head"><div class="tps-native-head-row"><div class="tps-native-title-block"><h1>' +
      pageTitle +
      '</h1><p class="tps-theme-count" data-tps-model-summary></p></div></div></header>' +
      '<form action="./" method="post" class="f8sr tps-native-toolbar-form"><fieldset>' +
      '<p class="tps-toolbar-search" data-tps-model-search><label><span class="hidden">Zoek binnen selectie</span><input type="search" name="zoek" data-tps-model-search-input autocomplete="off" value="' +
      escapeHtml(state.searchQuery || "") +
      '" placeholder="Zoek binnen selectie"></label></p><span class="hx" data-tps-toolbar-count></span>' +
      '<p class="link-btn desktop-hide"><a href="#filter" class="f8fl-toggle" aria-controls="filter" data-tps-open-mobile-filters><i aria-hidden="true" class="icon-filter"></i> Filteren</a></p>' +
      '<ul class="l4in strong list-hide mobile-hide" aria-controls="collection"><li><input type="radio" id="fsc" name="fsa" data-width="w25"><label for="fsc"><span>4</span></label></li><li><input type="radio" id="fsd" name="fsa" data-width="w20" checked><label for="fsd"><span>5</span></label></li></ul>' +
      '<ul class="l4vw" aria-controls="collection"><li class="active"><a href="./" aria-label="Grid display" data-tps-display="grid"><i aria-hidden="true" class="icon-view-grid"></i><span class="hidden">Raster weergave</span></a></li><li><a href="./" aria-label="List display" data-tps-display="list"><i aria-hidden="true" class="icon-view-list"></i><span class="hidden">Lijst weergave</span></a></li></ul>' +
      '<p class="tps-toolbar-sort"><span class="tps-sort-label">Sorteer op</span><span class="tps-sort-box" data-tps-sort-box><a href="#" class="tps-sort-current" data-tps-sort-current aria-expanded="false">' +
      escapeHtml(sortLabel(state.sort)) +
      '</a><span class="tps-sort-menu" data-tps-sort-menu>' +
      sortOptions +
      "</span></span></p>" +
      "</fieldset></form>" +
      '<ul id="collection" class="l4cl w20 w50-mobile mobile-scroll" data-tps-product-grid></ul>' +
      '<div class="tps-pagination tps-native-load-more" data-tps-pagination></div></main></div>';

    bindModelSearch(root, data, basePath);
    bindCollectionToolbar(root, data, basePath);
    bindModelNavigation(root, data, basePath);
    bindMobileFilterDrawer(root);
    bindNativeMobileWidth(root);
    renderModelState(root, data, basePath, state);
  }

  function initPages() {
    ensureNativeRuntimeStyles();
    document.querySelectorAll("[data-tps-scooter-page]").forEach(function (root) {
      if (root.getAttribute("data-ready") === "1" && root.getAttribute("data-ready-version") === "v29") return;
      root.setAttribute("data-ready", "1");
      root.setAttribute("data-ready-version", "v29");
      var mode = root.getAttribute("data-mode") || "finder";
      if (mode === "finder") {
        renderFinder(root);
        return;
      }
      var slug = root.getAttribute("data-model-slug") || "";
      if (!slug) {
        var handle = root.getAttribute("data-page-handle") || "";
        slug = handle.replace(/^scooter-/, "");
      }
      var payload = modelsPayload();
      var knownModel = payload.modelsBySlug && payload.modelsBySlug[slug];
      var knownMake = payload.makesBySlug && payload.makesBySlug[slug];
      var detailKind = knownModel ? "model" : knownMake ? "make" : "";
      root.innerHTML = '<p class="tps-loading">Onderdelen laden...</p>';
      loadDetailData(root, slug, detailKind)
        .then(function (data) {
          renderModel(root, data);
        })
        .catch(function (error) {
          root.innerHTML = '<div class="tps-error">' + escapeHtml(error.message) + "</div>";
        });
    });
  }

  function ready() {
    initProductFitment();
    initPages();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ready);
  else ready();
})();

